import ImageClass from "../../src/shell/Image";
import { jump } from "../../src/shell/jump";
import Question from "../../src/shell/Questions";
import { images } from "./images";

import { ann } from "../characters/Ann";
import { director } from "../characters/Director";
import { mc } from "../characters/MC";
import { mike } from "../characters/Mike";
import { tyler } from "../characters/Tyler";
import { doImageShake, doLoopImages, doPhoneRing, doSmsSound, doTransition, doWaitImageByTime, isAnnDidAnal, isAnnDidAnalWithChris, isAnnDidAnalWithMC, isAnnFuckedMCAndChrisTogether, isAnnGF, isAnnMotelHadSexWithBothGuys, isAnnMotelHadSexWithMike, isAnnMotelHadSexWithTyler, isMcLikesNTR } from "../helpers/helpers";
import { empty } from "../characters/empty";
import { V9AnnMCMotelAfter } from "./V9";
import { globals } from "../characters/globals";
import { stranger } from "../characters/Stranger";
import Game from "../../src/shell/Game";
import { Phone } from "../../src/components/phoneUI/PhoneClass";
import { endReplay } from "../../src/shell/endReplay";
import { replayScenesList } from "../../src/components/menu/Scenes/replayScenes/scenesReplayData";

const v9 = images.v9;
export const V9AnnMCMotel = async (): Promise<any> => {
    doWaitImageByTime(v9.V9MorningInstaAlexAnn);
    if (!ann.properties.v7ActressJob) {
        // If Ann failed the audition -> she'll call the MC.
        doSmsSound();
        mc.think(`It's Ann.`);
        await Phone.showMessagesUI({ name: ann.name }, async () => {
            Phone.setMessage({ character: ann.character, text: `You won't believe what I just found out.`, options: { wait: false } });
            Phone.setMessage({ character: mc.character, text: `Hey sweetie.` });
            Phone.setMessage({ character: ann.character, text: `Hey! You won't believe what I just found out.` });
            Phone.setMessage({ character: mc.character, text: `What?` });
            Phone.setMessage({ character: ann.character, text: `One of the actresses and a few extras for the director, ${director.name}, got sick!` });
            Phone.setMessage({ character: ann.character, text: `He's looking for replacements! This might be my second chance!` });
            Phone.setMessage({ character: mc.character, text: `Are you sure? He kinda kicked us out last time.` });
            Phone.setMessage({ character: ann.character, text: `I'm not going to give up on this!` });
            Phone.setMessage({ character: mc.character, text: `It seems like you've made up your mind about that.` });
            Phone.setMessage({ character: ann.character, text: `I did!` });
            Phone.setMessage({ character: ann.character, text: `Will you come with me?` });
            Phone.setMessage({ character: ann.character, text: `Pleaseeeee.` });
            Phone.setMessage({ character: ann.character, text: `He already thinks you are my agent...` });
            Phone.setMessage({ character: mc.character, text: `Where is it?` });
            Phone.setMessage({ character: ann.character, text: `Kinda far away...` });
            Phone.setMessage({ character: mc.character, text: `I see.` });
            Phone.setMessage({ character: mc.character, text: `You know what?` });
            Phone.setMessage({ character: mc.character, text: `I'll ask Emily if I can borrow her car and we can go.` });
            Phone.setMessage({ character: ann.character, text: `Really???` });

            Phone.closeMessagesUI();
        });
    } else {
        await doPhoneRing();
        // If Ann passed the audition and went to the director's hotel.
        mc.think(`The director is calling me.`);
        ImageClass.setImage(images.v9.V9MorningPhoneInstaAlexAnn);
        mc.talk(`Hello?`);
        director.talk(`Is your client still interested in a gig?`);
        mc.talk(`She is.`);
        director.talk(`I have an opening. Get here as soon as possible or the gig will be taken as Catfish Paradise.`);
        director.talk(`I'll send you the address via text.`);
        mc.think(`He hung up.`);
        ann.talk(`Hey ${mc.name}!`);
        mc.talk(`I have good news!`);
        doWaitImageByTime(v9.V9MorningInstaAlexAnn);
        mc.think(`Ann will be trilled!`);
        await Phone.showMessagesUI({ name: ann.name }, async () => {
            Phone.setMessage({ character: mc.character, text: `I have a surprise for you!`, options: { wait: false } });
            Phone.setMessage({ character: ann.character, text: `Tell me!` });
            Phone.setMessage({ character: mc.character, text: `I just got a call from the director, he might have a role for you!` });
            Phone.setMessage({ character: ann.character, text: `😲😲😲😲😲😲` });
            Phone.setMessage({ character: mc.character, text: `The only catch is that it's quite far.` });
            Phone.setMessage({ character: mc.character, text: `We don't have much time... We'll have to get going right now if we want to be there on time.` });
            Phone.setMessage({ character: ann.character, text: `That's not a catch! Let's go!` });
            Phone.setMessage({ character: ann.character, text: `How are we going to get there, by bus?` });
            // TODO: alpha -> scene of MC asking for the car.
            Phone.setMessage({ character: mc.character, text: `That will take too long. I'll just take Emily's car.` });
            Phone.setMessage({ character: ann.character, text: `Thank you!!! I'll go get ready!` });
            Phone.setMessage({ character: mc.character, text: `I think you should wear the same clothes you wore the last time I saw you.` });
            Phone.setMessage({ character: mc.character, text: `And also bring that sexy lingerie you showed me... Who knows... We might need it.` });
            Phone.setMessage({ character: ann.character, text: `Hehe! Okie!` });

            Phone.closeMessagesUI();
        });
    }

    mc.think(`Road trip it is.`);

    return jump(V9AnnMCMotel_Driving, `V9AnnMCMotel_Driving`);
};

export const V9AnnMCMotel_Driving = async (): Promise<any> => {
    doTransition(v9.V9AnnMCMotelDriving_0);
    ann.talk(`If you keep driving like this, we'll be there in no time!`);
    ImageClass.setImage(images.v9.V9AnnMCMotelDriving_10);
    mc.talk(`That's the plan!`);
    ImageClass.setImage(images.v9.V9AnnMCMotelDriving_3);
    ann.talk(`I'm so excited! I feel like I want to scream!`);
    ImageClass.setImage(images.v9.V9AnnMCMotelDriving_1);
    mc.talk(`What's stopping you?`);
    ImageClass.setImage(images.v9.V9AnnMCMotelDriving_0);
    ann.talk(`Hehe, seriously?`);
    mc.talk(`Yes, just do it.`);
    doWaitImageByTime(v9.V9AnnMCMotelDriving_12);
    ann.talk(`AHHHH!!!!!!`, { method: "Shouting" });
    doWaitImageByTime(v9.V9AnnMCMotelDriving_11);
    ann.talk(`AHHHHHHHH!!!!!!`, { method: "Shouting" });

    ImageClass.setImage(images.v9.V9AnnMCMotelDriving_9);
    ann.talk(`Much better!`);
    ImageClass.setImage(images.v9.V9AnnMCMotelDriving_13);
    mc.talk(`That's dangerous. You're lucky I'm a good driver.`);
    ImageClass.setImage(images.v9.V9AnnMCMotelDriving_9);
    await ann.setQuestion(new Question({ text: `I know!`, options: { think: false }, key: `v9AnnMCMotelDrivingAskedBlowjob` })
        .option({ title: `Ask for a blowjob`, key: true })
        .option({ title: `Just drive`, key: false }));

    if (Question.globalAnswers.v9AnnMCMotelDrivingAskedBlowjob) {
        ImageClass.setImage(images.v9.V9AnnMCMotelDriving_13);
        mc.talk(`However, it's a pretty long drive...`);
        mc.talk(`You wouldn't want me to fall asleep.`);
        ImageClass.setImage(images.v9.V9AnnMCMotelDriving_9);
        ann.talk(`You're right.`);
        ImageClass.setImage(images.v9.V9AnnMCMotelDriving_13);
        ann.talk(`Do you want me to keep talking so you won't fall asleep?`);
        ImageClass.setImage(images.v9.V9AnnMCMotelDriving_2);
        mc.talk(`I have something else in mind.`);
        ImageClass.setImage(images.v9.V9AnnMCMotelDriving_7);
        ann.talk(`Oh!`);
        doWaitImageByTime(v9.V9AnnMCMotelDriving_4);
        mc.talk(`Fuck yeah!`);
        mc.talk(`That feels so good!`);
        ImageClass.setImage(images.v9.V9AnnMCMotelDriving_5);
        mc.talk(`Now I want to drive slow so it will last forever!`);
        // FIXME: socks
        ImageClass.setImage(images.v9.V9AnnMCMotelDriving_6);
        ann.talk(`Mhmm!`);
        ImageClass.setImage(images.v9.V9AnnMCMotelDriving_5);
        mc.talk(`Ahh!!!`);
        doWaitImageByTime({ ...images.v9.V9AnnMCMotelDriving_13, partialsToDisplay: [images.v9.V9AnnMCMotelDriving_13.partials.V9AnnMCMotelDriving_13_p] });
        mc.talk(`You've gotten so good at that, felt like heaven.`);
        ImageClass.setImage(images.v9.V9AnnMCMotelDriving_14);
        ann.talk(`Hehe.`);

        ann.talk(`Let me know if you feel sleepy again.`);
        mc.talk(`You bet I will.`);
        endReplay(replayScenesList.V9AnnMCMotel_Driving);
    }
    endReplay();

    return jump(V9AnnMCMotel_2, `V9AnnMCMotel_2`);
};


export const V9AnnMCMotel_2 = async (): Promise<any> => {
    // TODO: alpha - remove for the final
    ImageClass.setImage(images.v2_5.BlackScreen);
    mc.think(`ALPHA MESSAGE: The following scene will be animated for the final release.`);

    doTransition(v9.V9AnnMCMotelArrival_0);
    mc.talk(`it's already dark; we should stay for the night.`);
    ann.talk(`I agree! I started getting a bit scared myself.`);
    doWaitImageByTime(v9.V9AnnMCMotelArrival_1);
    mc.talk(`Wait here, I'll go see if they have rooms available.`);
    ImageClass.setImage(images.v9.V9AnnMCMotelArrival_2);
    ann.talk(`Do it quick! It's scary being here alone.`);
    mc.talk(`Don't worry. I'll be back in a minute.`);
    doWaitImageByTime(v9.V9AnnMCMotelArrival_3);

    await mike.set((properties) => {
        mike.name = "Some Dude";
    });
    await tyler.set((properties) => {
        tyler.name = "Another Dude";
    });

    mike.talk(`Bro! I can't believe you lost your wallet.`);
    doWaitImageByTime(v9.V9AnnMCMotelArrival_4);
    tyler.talk(`Can't believe me? You didn't even bring one!`);
    mike.talk(`Because you always pay!`);
    mike.talk(`We're screwed! What are we going to do now?`);
    tyler.talk(`Chill. We'll figure it out like we always do.`);
    mike.talk(`As of right now, it looks like we're going to spend the night right here and hopefully can hitchhike in the morning.`);
    tyler.talk(`See? Not too bad...`);

    // MC back
    ImageClass.setImage(images.v9.V9AnnMCMotelArrival_1);
    mc.talk(`We're in luck! I got us a room!`);

    return jump(V9AnnMCMotel_InsideRoom, `V9AnnMCMotel_InsideRoom`);
};

export const V9AnnMCMotel_InsideRoom = async (): Promise<any> => {
    doWaitImageByTime(images.v9.V9AnnMCMotel_63);
    ann.talk(`Wow... This place is...`);
    mc.talk(`What you can expect from a cheap-ass motel.`);
    ann.talk(`I guess...`);
    ImageClass.setImage(images.v9.V9AnnMCMotel_63);
    ann.talk(`Do you think it's even safe to sleep on this bed?`);
    ImageClass.setImage(images.v9.V9AnnMCMotel_64);
    mc.talk(`Of course, the stains will scare all the spiders away.`);
    ImageClass.setImage(images.v9.V9AnnMCMotel_66.partials.V9AnnMCMotel_66_p, { putParent: true });
    ann.talk(`${mc.name}! Not funny! I won't be able to sleep.`);
    mc.talk(`Haha, relax.`);
    mc.talk(`I think you should go and change into that sexy outfit you showed me the other day.`);
    mc.talk(`I told you we'll find good use for it!`);
    ImageClass.setImage(images.v9.V9AnnMCMotel_66);
    ann.talk(`Hehe! Okay!`);
    doWaitImageByTime(images.v9.V9AnnMCMotel_67);
    ann.talk(`Don't go anywhere!`);
    doWaitImageByTime(v9.V9AnnMCMotel_121);
    mc.think(`Man. This place really is a shit hole...`);
    mc.think(`But it's only one night... At least we can try and make the most out of it.`);
    ann.talk(`${mc.name}...`);
    doWaitImageByTime(v9.V9AnnMCMotel_122);
    mc.talk(`Wow!`);
    mc.talk(`You look even hotter in person!`);
    doWaitImageByTime(v9.V9AnnMCMotel_124);
    ann.talk(`Hehe stop it!`);
    if (Question.globalAnswers.v1EnableNTR) {
        ImageClass.setImage(images.v9.V9AnnMCMotel_183);
        ann.talk(`I almost forgot to tell you!`);
        ann.talk(`Did you see the guys outside our room?`);
        ImageClass.setImage(images.v9.V9AnnMCMotel_124);
        mc.talk(`I haven't noticed them. Why?`);
        if (Question.globalAnswers.v8AnnDateFlashGuys) {
            ann.talk(`Small world, but those are the guys from the amusement park!`);
            mc.talk(`The ones you flashed your tits to?`);
            ImageClass.setImage(images.v9.V9AnnMCMotel_184);
            ann.talk(`...`);
            ann.talk(`Yes!`);
            mc.talk(`What about them?`);
        } else {
            ImageClass.setImage(images.v9.V9AnnMCMotel_184);
            ann.talk(`I feel a bit sad for them...`);
            mc.talk(`Why?`);
        }
        ImageClass.setImage(images.v9.V9AnnMCMotel_185);
        ann.talk(`I overheard them talking.`);
        ann.talk(`One of them lost his wallet and now they have to spend the night on the streets.`);
        if (isMcLikesNTR()) {
            ann.talk(`I was thinking... Maybe we should invite them here.`);
            mc.talk(`That's an interesting idea.`);
            if (Question.globalAnswers.v8AnnChrisWentToHouse) {
                ImageClass.setImage(images.v9.V9AnnMCMotel_185);
                ann.talk(`The other day at Chris' house was one of the best days of my life!`);
                ann.talk(`So maybe inviting them can be even more exciting...`);
            } else if (Question.globalAnswers.v8AnnChrisTextingSaidHeLovedIt) {
                ImageClass.setImage(images.v9.V9AnnMCMotel_185);
                ann.talk(`The texts exchange we had the other day while I was at Chris' house were really... Exciting to say the least.`);
                ann.talk(`So maybe... It will be even more exciting to do something similar in person.`);
            }
        }
        await ann.setQuestion(new Question({ text: `What do you say?`, options: { think: false }, key: `v9AnnMCMotelInviteGuysInside` })
            .option({ title: `Let's invite them`, key: true })
            .option({ title: `Don't invite them`, key: false }));

        if (Question.globalAnswers.v9AnnMCMotelInviteGuysInside) {
            return jump(V9AnnMCMotel_Invite_guys, "V9AnnMCMotel_Invite_guys");
        } else {
            mc.talk(`I'd rather spend the night alone with you.`);
            ImageClass.setImage(images.v9.V9AnnMCMotel_183);
            ann.talk(`Hehe. Okay!`);
        }
    }




    return jump(V9AnnMCMotel_Alone, "V9AnnMCMotel_Alone");
};

export const V9AnnMCMotel_Invite_guys = async (): Promise<any> => {
    ImageClass.setImage(v9.V9AnnMCMotel_124);
    mc.talk(`We can't let them stay outside... Let's invite them inside.`);
    ImageClass.setImage(images.v9.V9AnnMCMotel_185);
    ann.talk(`I agree.`);
    ImageClass.setImage(images.v9.V9AnnMCMotel_124);
    ann.talk(`Go and tell them that, while I'll go change.`);
    ImageClass.setImage(v9.V9AnnMCMotel_124);
    mc.talk(`Me? It's your idea.`);
    ImageClass.setImage(images.v9.V9AnnMCMotel_187);
    mc.talk(`Besides, if you want them to accept, you should go out like that; they won't say no.`);
    ImageClass.setImage(images.v9.V9AnnMCMotel_186);
    ann.talk(`I can't! They are strangers!`);
    ImageClass.setImage(images.v9.V9AnnMCMotel_187);
    if (Question.globalAnswers.v8AnnDateFlashGuys) {
        mc.talk(`They already saw your boobs.`);
    } else {
        mc.talk(`They won't be strangers soon. You want them to sleep with us in the same room, right?`);
    }
    ImageClass.setImage(images.v9.V9AnnMCMotel_184);
    ann.talk(`I guess you're right...`);
    ImageClass.setImage(images.v9.V9AnnMCMotel_185);
    ann.talk(`Wait here.`);
    doWaitImageByTime(v9.V9AnnMCMotel_0);
    mc.think(`She is really doing it.`);
    ImageClass.setImage(v9.V9AnnMCMotel_1);
    ann.talk(`They are still here!`, { method: "Whispering" });
    mc.talk(`Go for it.`);
    ImageClass.setImage(v9.V9AnnMCMotel_1.partials.V9AnnMCMotel_1_p);
    ann.talk(`I will! I'm just collecting myself for a second.`);
    ann.talk(`Okay.`);
    doWaitImageByTime(v9.V9AnnMCMotel_1.partials.V9AnnMCMotel_0_p);
    mc.think(`She really left outside wearing that revealing nightgown.`);
    mc.think(`...`);
    doWaitImageByTime(v9.V9AnnMCMotel_1.partials.V9AnnMCMotel_0_p_2);
    mc.think(`Any minute now...`);
    // Door opened.
    doWaitImageByTime(v9.V9AnnMCMotel_188.partials.V9AnnMCMotel_188_p, { putParent: true });
    mike.talk(`Hey bro! It was really kind of you to invite us to stay the night!`);
    ImageClass.setImage(v9.V9AnnMCMotel_188.partials.V9AnnMCMotel_188_p_2, { putParent: true });
    tyler.talk(`Yes, we were completely done for if you hadn't.`);
    ImageClass.setImage(images.v9.V9AnnMCMotel_188);
    mc.talk(`You're welcome.`);
    await tyler.set((properties) => {
        tyler.name = "Tyler";
    });
    await mike.set((properties) => {
        mike.name = "Mike";
    });
    ImageClass.setImage(images.v9.V9AnnMCMotel_190);
    tyler.talk(`I'm Tyler.`);
    ImageClass.setImage(images.v9.V9AnnMCMotel_188.partials.V9AnnMCMotel_188_p_2, { putParent: true });
    mike.talk(`Mike.`);
    if (Question.globalAnswers.v8AnnDateFlashGuys) {
        doWaitImageByTime(v9.V9AnnMCMotel_192);
        tyler.talk(`I already apologized to Ann for taking her picture at the amusement park.`);
        tyler.talk(`But you know how it is...`);
        ImageClass.setImage(v9.V9AnnMCMotel_191);
        tyler.talk(`A girl flashes you, and you have your phone in your hand, you just snap a photo.`);
        ImageClass.setImage(v9.V9AnnMCMotel_193);
        mc.talk(`It seemed like you practiced for the moment.`);
        ImageClass.setImage(v9.V9AnnMCMotel_191);
        tyler.talk(`Haha, what can I say? I'm quick with my fingers.`);
        tyler.talk(`I can delete the photo right now if you want.`);
        ImageClass.setImage(v9.V9AnnMCMotel_193);
        mc.talk(`I'm sure you've sent it around already.`);
        doWaitImageByTime(v9.V9AnnMCMotel_195);
        tyler.talk(`Let me think...`);
        doWaitImageByTime(v9.V9AnnMCMotel_197);
        mike.talk(`He's not stupid, bro.`);
        doWaitImageByTime(v9.V9AnnMCMotel_196);
        tyler.talk(`You gave us a place to stay, I don't want to fuck that up.`);
        ImageClass.setImage(v9.V9AnnMCMotel_193);
        mc.talk(`We're cool, don't sweat it.`);
    } else {
        ImageClass.setImage(v9.V9AnnMCMotel_198);
        mike.talk(`You know, we recognized you two from the amusement park.`);
        ImageClass.setImage(v9.V9AnnMCMotel_199);
        mc.talk(`You must have a good memory.`);
        ImageClass.setImage(v9.V9AnnMCMotel_200);
        mike.talk(`Yeah... I do.`);
        mc.think(`I bet the only part he remembers is Ann's ass.`);
    }
    doWaitImageByTime(v9.V9AnnMCMotel_193);
    mc.talk(`We had a long drive; we should get some rest.`);

    doWaitImageByTime(v9.V9AnnMCMotel_201);
    ann.talk(`I don't think this bed will fit the four of us.`);
    ImageClass.setImage(v9.V9AnnMCMotel_202);
    tyler.talk(`No way I'm sleeping in the same bed with Mike!`);
    ImageClass.setImage(v9.V9AnnMCMotel_195);
    tyler.talk(`Besides, I'm a hugger. I don't want to hug him by accident.`);
    ImageClass.setImage(v9.V9AnnMCMotel_203);
    mike.talk(`Man, we've done worse things than sleeping in the same bed.`);
    ImageClass.setImage(v9.V9AnnMCMotel_197);
    tyler.talk(`Bro.`);

    doWaitImageByTime(v9.V9AnnMCMotel_193);
    mc.talk(`That raises the question...`);
    mc.talk(`What do two guys do at the amusement park?`);

    ImageClass.setImage(v9.V9AnnMCMotel_197);
    tyler.talk(`You see! I told you people would ask questions.`);
    ImageClass.setImage(v9.V9AnnMCMotel_203);
    mike.talk(`How was I supposed to know there would be only couples there?`);
    ImageClass.setImage(v9.V9AnnMCMotel_195);
    tyler.talk(`Mr. Genius here told me the amusement park is filled with single girls...`);
    ImageClass.setImage(v9.V9AnnMCMotel_202);
    tyler.talk(`There were only couples there!`);
    doWaitImageByTime(v9.V9AnnMCMotel_193);
    mc.talk(`How does that explain you two getting on the ferris wheel?`);
    ImageClass.setImage(v9.V9AnnMCMotel_195);
    tyler.talk(`We were just there, so we said fuck it...`);
    doWaitImageByTime(v9.V9AnnMCMotel_193);
    mc.talk(`That makes sense...`);
    ImageClass.setImage(v9.V9AnnMCMotel_203);
    mike.talk(`He doesn't buy it.`);
    doWaitImageByTime(v9.V9AnnMCMotel_193);
    mc.talk(`Nope.`);
    ImageClass.setImage(v9.V9AnnMCMotel_202);
    tyler.talk(`I told you!`);
    ImageClass.setImage(v9.V9AnnMCMotel_204);
    ann.talk(`Hehe!`);

    mc.talk(`Let's get back to our sleeping arrangement.`);
    doWaitImageByTime(v9.V9AnnMCMotel_198);
    mike.talk(`We can both sleep on the floor. You've already done more than enough.`);
    ImageClass.setImage(v9.V9AnnMCMotel_205);
    ann.talk(`You can't sleep on the floor!`);
    ImageClass.setImage(v9.V9AnnMCMotel_193);
    mc.talk(`Let me think...`);
    mc.talk(`We have a sofa, and the bed can fit three people...`);
    return jump(V9AnnMCMotel_InviteGuys_SofaQuestion, "V9AnnMCMotel_InviteGuys_SofaQuestion");
};

export const V9AnnMCMotel_InviteGuys_SofaQuestion = async (): Promise<any> => {
    await mc.setQuestion(new Question({ text: `Who would sleep on the sofa?`, options: { think: true, array: "v9AnnMCMotelGuysInsideWhoSleepSofaArr" }, key: `v9AnnMCMotelGuysInsideWhoSleepSofa` })
        .option({ title: `I will`, key: `mc` })
        .option({ title: `Tyler (left)`, key: `tyler` })
        .option({ title: `mike (right)`, key: `mike` })
        .option({ title: `Ann`, key: `ann`, hide: Question.globalAnswers.v9AnnMCMotelGuysInsideWhoSleepSofaArr?.includes('ann') }));


    if (Question.globalAnswers.v9AnnMCMotelGuysInsideWhoSleepSofa === "ann") {
        mc.talk(`I think Ann should sleep on the sofa.`);
        ImageClass.setImage(v9.V9AnnMCMotel_195);
        tyler.talk(`What? No way man!`);
        ImageClass.setImage(v9.V9AnnMCMotel_198);
        mike.talk(`I agree, no way I'm going to share a bed with two other guys!`);
        mike.talk(`I'll take the floor...`);
        ImageClass.setImage(v9.V9AnnMCMotel_193);
        mc.talk(`I was just messing with you.`);
        ImageClass.setImage(images.v9.V9AnnMCMotel_200);
        mike.talk(`Oh, Haha...`);
        return jump(V9AnnMCMotel_InviteGuys_SofaQuestion, "V9AnnMCMotel_InviteGuys_SofaQuestion");

    } else if (Question.globalAnswers.v9AnnMCMotelGuysInsideWhoSleepSofa === "mike") {
        mc.talk(`Mike should sleep on the sofa.`);
        ImageClass.setImage(images.v9.V9AnnMCMotel_206);
        tyler.talk(`Haha, damn bro you got fucked!`);
        ImageClass.setImage(images.v9.V9AnnMCMotel_207);
        mike.talk(`Fucked? That sofa looks cleaner than the bed.`);
        tyler.talk(`Yeah... You might be right...`);


    } else if (Question.globalAnswers.v9AnnMCMotelGuysInsideWhoSleepSofa === "tyler") {
        mc.talk(`Tyler will take the sofa.`);
        ImageClass.setImage(images.v9.V9AnnMCMotel_195);
        tyler.talk(`Man! I knew you'd pick me! I always gets fucked!`);
        ImageClass.setImage(images.v9.V9AnnMCMotel_207);
        mike.talk(`Bro, you literally got everything you want in life since you were a child.`);
        tyler.talk(`You don't have to say that in front of them!`);
        mike.talk(`Just take the damn sofa!`);

    } else if (Question.globalAnswers.v9AnnMCMotelGuysInsideWhoSleepSofa === "mc") {
        ImageClass.setImage(v9.V9AnnMCMotel_193);
        mc.talk(`You guys can sleep on the bed, I'll take the sofa?`);
        doWaitImageByTime(v9.V9AnnMCMotel_208);
        ann.talk(`Pst!`);
        ann.talk(`Can you follow me for a second?`);
        mc.talk(`Of course.`);

        doWaitImageByTime(v9.V9AnnMCMotel_209);
        ann.talk(`Are you sure about that?`);
        ImageClass.setImage(v9.V9AnnMCMotel_210);
        mc.talk(`I am.`);
        mc.talk(`I didn't take the sofa for the kindness of my heart.`);
        mc.talk(`Just try to enjoy the experience and make the most of it.`);
        mc.talk(`I'll be right across the room if you start to feel unsafe.`);
        if (isMcLikesNTR()) {
            ImageClass.setImage(v9.V9AnnMCMotel_211);
            ann.talk(`Hehe. I won't lie... I had a feeling you'd choose the sofa.`);
        } else {

        }
        ImageClass.setImage(v9.V9AnnMCMotel_212);
        ann.talk(`I love you! Muah!`);

        doWaitImageByTime(v9.V9AnnMCMotel_213);
        tyler.talk(`Is there a problem? We still don't mind sleeping on the floor.`);
        mc.talk(`Everything is fine, I just wished her good night.`);

    }
    ImageClass.setImage(images.v9.V9AnnMCMotel_200);
    mike.talk(`It's all settled then!`);

    if (Question.globalAnswers.v9AnnMCMotelGuysInsideWhoSleepSofa === "mc") {
        doWaitImageByTime(v9.V9AnnMCMotel_3, null, 2);

    } else {

        doWaitImageByTime(v9.V9AnnMCMotel_214, null, 2);
    }
    ann.talk(`Good night everyone!`);
    await stranger.set((properties) => {
        stranger.name = "Everyone";
    });
    stranger.talk(`Good night!`);

    if (Question.globalAnswers.v9AnnMCMotelGuysInsideWhoSleepSofa === "mc") {

        return jump(V9AnnMCMotel_InviteGuys_MC_Sofa, "V9AnnMCMotel_InviteGuys_MC_Sofa");
    }

    return jump(V9AnnMCMotel_InviteGuys_MCNotSofa, "V9AnnMCMotel_InviteGuys_MCNotSofa");


};
export const V9AnnMCMotel_InviteGuys_MC_Sofa = async (): Promise<any> => {
    doWaitImageByTime(images.v2_5.BlackScreen, undefined, 1);
    doWaitImageByTime(v9.V9AnnMCMotel_4);
    mc.think(`As I lay on the sofa trying to rest my eyes, I couldn't stop thinking about what was going to happen next.`);
    mc.think(`I left Ann sleeping in a bed between two strangers.`);
    doWaitImageByTime(v9.V9AnnMCMotel_3);
    mc.think(`Sure, they seem cool and all, but still...`);
    doWaitImageByTime(v9.V9AnnMCMotel_5);
    mc.think(`It's out of my hands at this point. I guess I'll just have to wait and see...`);
    doWaitImageByTime(images.v2_5.BlackScreen, undefined, 2);
    doWaitImageByTime(v9.V9AnnMCMotel_6);
    mc.think(`Some time has passed, and Tyler and Ann were cuddling.`);
    mc.think(`In his defense, he did say he is a hugger.`);
    doWaitImageByTime(v9.V9AnnMCMotel_7);
    mc.think(`It seemed harmless at first...`);
    doWaitImageByTime(v9.V9AnnMCMotel_34);
    mc.think(`But then he reached his hand down Ann's panties.`);
    mc.think(`It soon became clear whether Ann was fully awake at that point.`);
    doWaitImageByTime(v9.V9AnnMCMotel_35);
    mc.think(`She reacted by opening her legs and giving him better access.`);
    doWaitImageByTime(v9.V9AnnMCMotel_36);
    mc.think(`Without talking or even opening her eyes, she responded by reaching down his pants and grabbing his cock.`);
    // TODO: render -maybe change renders like 37 to lighting like 214
    tyler.talk(`Hey gorgeous, I'd like you to taste me.`);
    doWaitImageByTime(v9.V9AnnMCMotel_39);
    mc.think(`Ann turned around and slowly started to lick Tyler's tip.`);
    mc.think(`Tyler's breathing slowly became heavier and faster.`);
    doWaitImageByTime(v9.V9AnnMCMotel_38);
    mc.think(`It caught Mike's attention, who suddenly opened his eyes.`);
    doWaitImageByTime(v9.V9AnnMCMotel_37);
    mc.think(`I kept lying on the sofa across the room, watching.`);
    doWaitImageByTime(v9.V9AnnMCMotel_41);
    mc.think(`Not really knowing Ann, Mike slowly put his hand on Ann's ass, testing to see how she'd react.`);
    doWaitImageByTime(v9.V9AnnMCMotel_40);
    mc.think(`She didn't budge as she was expecting it.`);
    mike.talk(`How about giving me some love as well?`);
    doWaitImageByTime(v9.V9AnnMCMotel_42);
    mc.think(`Ann turned to Mike, revealing his cock.`);
    // TODO: animate or add another render
    mc.think(`She kept stroking it while he and Tyler exchanged looks.`);
    if (isAnnGF()) {
        mc.think(`They were both lying in bed, enjoying the touch of a stranger. My girlfriend.`);
    } else {
        // TODO: Ann hate
    }

    doWaitImageByTime(v9.V9AnnMCMotel_43);
    mc.think(`Suddenly, Ann stopped and kneeled on the bed.`);
    mc.think(`She knew I was watching.`);
    mc.think(`Her hands were on the nightgown collars...`);
    doWaitImageByTime(v9.V9AnnMCMotel_44);
    mc.think(`She didn't care about the guys. She was doing it for me.`);
    doWaitImageByTime(v9.V9AnnMCMotel_45);
    mc.think(`I lay there quietly as she lowered her nightgown.`);
    mc.think(`She might be doing it for me, but Mike saw it as an invitation.`);
    doWaitImageByTime(v9.V9AnnMCMotel_46);
    mike.talk(`He removed his shorts completely and started kissing her neck.`);
    doWaitImageByTime(v9.V9AnnMCMotel_47);
    mc.think(`Ann couldn't hide it. She was enjoying every minute of it.`);
    if (isMcLikesNTR()) {
        mc.think(`And I enjoyed watching her.`);
    } else {
        mc.think(`I was a bit worried she might be enjoying it a little too much, but I kept my mouth shut.`);
    }
    doWaitImageByTime(v9.V9AnnMCMotel_48);
    mc.think(`She was making sure I wouldn't turn my eyes away.`);
    mc.think("I told her that I would be here making sure she is safe, and that's what I did.");
    doWaitImageByTime(v9.V9AnnMCMotel_46);
    mc.think(`I started to understand that the fact I was watching was what made her enjoy it so much.`);
    doWaitImageByTime(v9.V9AnnMCMotel_49);
    mc.think(`She leaned forward and took Tyler's cock inside her mouth.`);
    mc.think(`She kept eye contact as she was sucking him.`);
    doWaitImageByTime(v9.V9AnnMCMotel_50);
    mc.think(`It was clearly too big for her, as her drool started to drip down his shaft.`);
    doWaitImageByTime(v9.V9AnnMCMotel_51);
    mc.think(`She hesitated for a second as Mike took off her panties.`);
    doWaitImageByTime(v9.V9AnnMCMotel_52);
    mc.think(`He started banging his cock on her ass, signaling to her that he was about to conquer her pussy.`);
    if (Question.globalAnswers.v8AnnChrisWentToHouse || Question.globalAnswers.v8AnnChrisTextingAskMorePhotos) {
        mc.think(`I already saw Chris and Ann together, but this time it's different.`);
        mc.think(`They are strangers.`);
    } else if (Question.globalAnswers.V8AnnDateMCOkWithChris) {
        mc.think(`I know Ann and Chris are fooling around, but this time I'm going to see Ann being intimate with not one, but two.`);
        mc.think(`And they are complete strangers.`);
    }
    doWaitImageByTime(v9.V9AnnMCMotel_53);
    mc.think(`And then it happened.`);
    doWaitImageByTime(v9.V9AnnMCMotel_54);
    mc.think(`Mike slid his cock inside Ann's vagina.`);
    doWaitImageByTime(v9.V9AnnMCMotel_55);
    mc.think(`Ann knew it was about to come, but was still surprised.`);
    mc.think(`She suddenly realized the situation.`);
    mc.think(`She is sucking one cock while another is fucking her and neither one of them is me.`);
    if (isAnnFuckedMCAndChrisTogether()) {
        mc.think(`Sure, she already did it with me and Chris.`);
        mc.think(`But we were two guys she considers boyfriends and loves.`);
    }

    mike.talk(`You are so tight you are killing me.`);
    doWaitImageByTime(v9.V9AnnMCMotel_216);
    tyler.talk(`Move over, I want to feel her.`);
    mc.think(`Mike moved over as Tyler positioned himself behind Ann.`);
    doWaitImageByTime(v9.V9AnnMCMotel_219);
    mc.think(`She was about to experience the feeling of a stranger entering her once again.`);
    doWaitImageByTime(v9.V9AnnMCMotel_218);
    mc.think(`Tyler slowly pushed himself inside her.`);
    mc.think(`They kept fucking her for a few minutes, switching positions when they saw fit.`);
    doWaitImageByTime(v9.V9AnnMCMotel_217);
    mc.think(`Our eyes met again; she wanted to make sure I was still watching and protecting her.`);
    mc.think(`She was enjoying it, and I had no intention of ruining it for her.`);
    doWaitImageByTime(v9.V9AnnMCMotel_220);
    tyler.talk(`Hey gorgeous, do you do anal?`);
    doWaitImageByTime(v9.V9AnnMCMotel_221);
    ann.talk(`A-Anal?`);
    if (isAnnDidAnal()) {
        ann.talk(`Not a lot... It still hurts...`);
        ImageClass.setImage(images.v9.V9AnnMCMotel_220);
        tyler.talk(`I'll be gentle.`);
        mc.think(`She barely has any experience with it.`);
        if (isAnnDidAnalWithMC() && isAnnDidAnalWithChris()) {
            mc.think(`She's only experienced this twice... With me and Chris.`);
        } else if (isAnnDidAnalWithMC()) {
            mc.think(`She only did it with me.`);
        } else {
            mc.think(`She only did it once with Chris.`);
        }
        mc.think(`And it barely got inside her ass.`);
    } else if (Question.globalAnswers.V1NtrUnexpected) {
        ann.talk(`No... But I can try if that's what you like.`);
        mc.think(`What? She never tried anal!`);
        mc.think(`Not with a real cock at least...`);
        mc.think(`But she is going to let him try it...`);
        ImageClass.setImage(images.v9.V9AnnMCMotel_220);
        tyler.talk(`Don't worry. I'll be gentle.`);
    } else {
        ann.talk(`No, I don't...`);
        ImageClass.setImage(images.v9.V9AnnMCMotel_220);
        tyler.talk(`I wanted to feel your ass before I come, but pussy it is!`);
    }
    return jump(V9AnnMCMotel_InviteGuys_MC_Sofa_2, "V9AnnMCMotel_InviteGuys_MC_Sofa_2");
};
export const V9AnnMCMotel_InviteGuys_MC_Sofa_2 = async (): Promise<any> => {
    if (isAnnDidAnal() || Question.globalAnswers.V1NtrUnexpected) {
        doWaitImageByTime(images.v9.V9AnnMCMotel_222);
        mc.think(`Tyler positioned himself behind and ready to conquer another hole.`);
        doWaitImageByTime(images.v9.V9AnnMCMotel_223);
        mc.think(`Tyler slowly inserted his tip inside Ann's ass.`);
        doWaitImageByTime(images.v9.V9AnnMCMotel_222);
        ann.talk(`Mhmmm!`);
        doWaitImageByTime(images.v9.V9AnnMCMotel_223);
        mc.think(`She clearly felt the size of him trying to push into this tight spot.`);
        doWaitImageByTime(images.v9.V9AnnMCMotel_222);
        mc.think(`Yet, she didn't move.`);
        doWaitImageByTime(images.v9.V9AnnMCMotel_59);
        mc.think(`Tyler kept pushing it in slowly.`);

        tyler.talk(`Girl, you are killing me.`);
        doWaitImageByTime(v9.V9AnnMCMotel_58);
        mc.think(`This whole situation was surreal.`);
        doWaitImageByTime(images.v9.V9AnnMCMotel_57);
        mc.think(`Two guys were doing everything they want with my girl, right in front of me.`);
        doWaitImageByTime(images.v9.V9AnnMCMotel_224);
        mc.think(`She kept sucking Mike's cock as Tyler continued fucking her forbidden hole.`);
        doWaitImageByTime(images.v9.V9AnnMCMotel_226);
        mike.talk(`Bro, you better not cum inside before I get my turn!`);
        tyler.talk(`You should try it now because I'm about to pop.`);
        doWaitImageByTime(v9.V9AnnMCMotel_227);
        mc.think(`Mike wasted no time at all. He quickly insert his dick inside her ass.`);
        ann.talk(`Ah!`);
        mc.think(`Again, only his tip fit inside Ann's tight ass.`);
        mike.talk(`Damn! You weren't kidding; she is tight as hell!`);

        doWaitImageByTime(images.v9.V9AnnMCMotel_228);
        mc.think(`As they switched positions, Ann hesitated for a moment.`);
        mc.think(`She knew that his cock was just inside her ass.`);
        tyler.talk(`Come on, don't do me like that.`);
        doWaitImageByTime(images.v9.V9AnnMCMotel_229);
        mc.think(`She didn't want to disappoint.`);
        mc.think(`She licked the tip to see how it tastes.`);
        mc.think(`It didn't taste bad at all. So, Ann decided she'd continue to please.`);
        mc.think(`She put his cock inside her mouth.`);
        doWaitImageByTime(images.v9.V9AnnMCMotel_60);
        mc.think(`While Mike was still doing his thing.`);

        mc.think(`And it didn't take long.`);
        doWaitImageByTime(images.v9.V9AnnMCMotel_230);
        mc.think(`The excitement made Tyler cum inside Ann's mouth.`);
        tyler.talk(`Fuck!!!`);

        doWaitImageByTime(images.v9.V9AnnMCMotel_60);
        mike.talk(`Fuck! I'm cumming as well!`);
        doWaitImageByTime(images.v9.V9AnnMCMotel_231);
        mc.think(`In perfect sync, as Tyler came inside Ann's mouth, Mike came inside Ann's ass.`);
        doWaitImageByTime(images.v9.V9AnnMCMotel_232);
        ann.talk(`Oh my...`);
        mike.talk(`You are perfect.`);
    } else {
        doWaitImageByTime(images.v9.V9AnnMCMotel_235);
        mc.think(`Tyler kept fucking Ann's tight pussy until...`);

        doWaitImageByTime(images.v9.V9AnnMCMotel_236);
        tyler.talk(`Fuck!!!`);
        ImageClass.setImage(images.v9.V9AnnMCMotel_237);
        mike.talk(`Bro!`);
        mike.talk(`I wanted to finish there!`);
        // FIXME: focus
        doWaitImageByTime(images.v9.V9AnnMCMotel_238);
        tyler.talk(`Go ahead.`);
        mike.talk(`No way I'm going for sloppy seconds.`);
        tyler.talk(`Sorry man, she's so tight I couldn't hold it anymore.`);
        doWaitImageByTime(images.v9.V9AnnMCMotel_239);
        ann.talk(`Do... You want me to go clean up?`);
        mike.talk(`Just keep going, I'll cum any minute now.`);
        doWaitImageByTime(images.v9.V9AnnMCMotel_240);
        mc.think(`Ann continued to suck Mike's cock, trying to make him climax.`);
        doWaitImageByTime(images.v9.V9AnnMCMotel_241);
        mc.think(`She kept eye contact with me as she was doing her best to make him cum.`);
        doWaitImageByTime(images.v9.V9AnnMCMotel_242);
        mc.think(`She sucked his cock but was actually trying to please me.`);
        mc.think(`Ann kept stroking and sucking Mike's cock until he was ready...`);
        doWaitImageByTime(images.v9.V9AnnMCMotel_243);
        doWaitImageByTime(images.v9.V9AnnMCMotel_244);
        mike.talk(`Ahhh!`);
    }

    doWaitImageByTime(v9.V9AnnMCMotel_245);
    ann.talk(`${mc.name}?`);
    // autoadd V9AnnMCMotel_248
    doWaitImageByTime(v9.V9AnnMCMotel_246);
    if (Question.globalAnswers.V1NtrUnexpected && mc.properties.v8AnnChrisHouseKissedAnn?.includes("cumchris")) {
        ann.talk(`I came to tell you that I love you and to wish you good night.`);
        mc.think(`Maybe it was the fact that I kissed her after Chris came in her mouth.`);
        mc.think(`Or maybe she just didn't care.`);
        doWaitImageByTime(v9.V9AnnMCMotel_249);
        mc.think(`Ann leaned over and started to kiss me.`);
    } else {
        await ann.setQuestion(new Question({ text: `I came to tell you that I love you and to wish you good night.`, options: { think: false }, key: `v9AnnMCMotlMCSofaKissedHer` })
            .option({ title: `Kiss her good night`, key: true })
            .option({ title: `Say good night`, key: false }));

        if (Question.globalAnswers.v9AnnMCMotlMCSofaKissedHer) {
            if (!isAnnDidAnal() && !Question.globalAnswers.V1NtrUnexpected) {
                mc.think(`I saw Ann's face.`);
            } else {
                mc.think(`I know Tyler just came inside her mouth.`);
            }
            mc.think(`But that didn't deter me at all.`);

            doWaitImageByTime(v9.V9AnnMCMotel_249);
        } else {

            doWaitImageByTime(v9.V9AnnMCMotel_246.partials.V9AnnMCMotel_248);
        }
        mc.talk(`Good night, honey.`);
    }


    // Autoadd V9AnnMCMotel_233
    doWaitImageByTime(images.v9.V9AnnMCMotel_234);
    mc.think(`And that's how a wild night filled with passion and excitement ends.`);
    mc.think(`With me watching from the sidelines.`);

    mc.think(`Night.`);
    endReplay(replayScenesList.V9AnnMCMotel_InviteGuys_MC_Sofa);

    return jump(V9AnnMCMotel_Morning, "V9AnnMCMotel_Morning");
};


// proofed till here:
export const V9AnnMCMotel_InviteGuys_MCNotSofa = async (): Promise<any> => {
    doWaitImageByTime(images.v2_5.BlackScreen);
    doWaitImageByTime(v9.V9AnnMCMotel_9, { wait: true });

    doWaitImageByTime(v9.V9AnnMCMotel_9.partials.V9AnnMCMotel_9_p);

    ann.talk(`Pst ${mc.name}.`, { method: "Whispering" });
    await ann.setQuestion(new Question({ text: `Are you awake?`, options: { method: "Whispering", think: false }, key: `v9AnnMCMotelPretendToBeAsleep` })
        .option({ title: `Pretend to sleep`, key: true, disabled: true, info: "Will be available for the final version" })
        .option({ title: `Answer her`, key: false }));


    let annQuestionLine = `Hehe, they said they had a rough day.`;
    if (Question.globalAnswers.v9AnnMCMotelPretendToBeAsleep) {
        ann.talk(`...`);
        doWaitImageByTime(v9.V9AnnMCMotel_9);
        ann.talk(`I guess not.`, { method: "Whispering" });
        return jump(V9AnnMCMotel_InviteGuys_MCNotSofa_MCSleeping, "V9AnnMCMotel_InviteGuys_MCNotSofa_MCSleeping");

    }
    ImageClass.setImage(images.v9.V9AnnMCMotel_10);
    mc.talk(`Yes, what happened?`, { method: "Whispering" });
    ImageClass.setImage(v9.V9AnnMCMotel_11);
    ann.talk(`I can't sleep. My heart is racing!`, { method: "Whispering" });
    ImageClass.setImage(images.v9.V9AnnMCMotel_12);
    mc.talk(`Why? What's wrong?`, { method: "Whispering" });
    ImageClass.setImage(v9.V9AnnMCMotel_11);
    ann.talk(`Sleeping next to a stranger!`, { method: "Whispering" });
    // ImageClass.setImage(images.v9.V9AnnMCMotel_12);
    // mc.talk(`He doesn't look like he has problem with that.`, { method: "Whispering" });
    // if (Question.globalAnswers.V1NtrUnexpected) {
    // TODO: redo this entire section - it's meh
    //     ImageClass.setImage(v9.V9AnnMCMotel_11);
    //     ann.talk(`What do you think about him?`, { method: "Whispering" });
    //     ImageClass.setImage(images.v9.V9AnnMCMotel_12);
    //     mc.talk(`What should I think? He is a cool dude.`, { method: "Whispering" });
    //     if (Question.globalAnswers.v8AnnChrisTextingSaidHeLovedIt
    //         || Question.globalAnswers.v8AnnChrisWentToHouse
    //         // || mc.properties.v8AnnChrisHouseKissedAnn?.includes("cumchris")
    //         // || mc.properties.v8AnnChrisHouseKissedAnn?.includes("bjChris")
    //         // || mc.properties.v8AnnChrisHouseKissedAnn?.includes("doggychris")
    //         // || mc.properties.v8AnnChrisHouseKissedAnn?.includes("ridingchris")
    //     ) {
    //         ImageClass.setImage(v9.V9AnnMCMotel_11);
    //         ann.talk(`I keep thinking about the other day with Chris.`, { method: "Whispering" });
    //         if (Question.globalAnswers.v8AnnChrisTextingSaidHeLovedIt) {
    //             ann.talk(`You were excited to see the pictures I sent you.`, { method: "Whispering" });

    //         }
    //         // TODO: maybe take expression from 17 and 18
    //         ann.talk(`I want to make you happy again.`, { method: "Whispering" });
    //         ann.talk(`But this is so crazy!`, { method: "Whispering" });
    //         ann.talk(`It's not like Chris... I know him already and I'm used to him... `, { method: "Whispering" });
    //         ann.talk(`But... Maybe...`, { method: "Whispering" });
    //     }

    //     ann.talk(`Would you got jealous if he touched me?`, { method: "Whispering" });
    //     ImageClass.setImage(images.v9.V9AnnMCMotel_12);
    //     mc.talk(`I think there might be one way to find out...`, { method: "Whispering" });
    //     annQuestionLine = `Oh! What are you saying?`;
    // }


    await ann.setQuestion(new Question({ text: `Sleeping next to a stranger!`, options: { think: false, method: "Whispering" }, key: `v9AnnMCMotelMCBedGuyOption` })
        .option({ title: `Cuddle with Ann`, key: `cuddleWithAnn` })
        .option({ title: `Mess around with ${Question.globalAnswers.v9AnnMCMotelGuysInsideWhoSleepSofa === "mike" ? "Tyler" : "Mike"}`, key: `foolAroundWithHim` })
        .option({ title: Question.globalAnswers.V1NtrUnexpected ? `Nevermind let's go to sleep` : `Tell her to try to sleep`, key: `trySleep`, disabled: true, info: "Will be available for the final version" }));

    if (Question.globalAnswers.v9AnnMCMotelMCBedGuyOption === "trySleep") {
        ImageClass.setImage(images.v9.V9AnnMCMotel_12);
        mc.talk(`It's been a long day, just try to get some sleep.`, { method: "Whispering" });
        ImageClass.setImage(images.v9.V9AnnMCMotel_10);
        ann.talk(`Okay... Good night!`, { method: "Whispering" });
        return jump(V9AnnMCMotel_InviteGuys_MCNotSofa_MCSleeping, "V9AnnMCMotel_InviteGuys_MCNotSofa_MCSleeping");
    }

    if (Question.globalAnswers.v9AnnMCMotelMCBedGuyOption === "cuddleWithAnn") {
        ImageClass.setImage(images.v9.V9AnnMCMotel_12);
        if (Question.globalAnswers.V1NtrUnexpected) {
            mc.talk(`Never mind. Come here I'll help you sleep.`, { method: "Whispering" });

        } else {
            mc.talk(`Come here I'll help you sleep.`, { method: "Whispering" });

        }
        doWaitImageByTime(v9.V9AnnMCMotel_96);
        ann.talk(`That feels nice!`, { method: "Whispering" });
        ann.talk(`Good night!`, { method: "Whispering" });
        return jump(V9AnnMCMotel_InviteGuys_MCNotSofa_Cuddling, "V9AnnMCMotel_InviteGuys_MCNotSofa_Cuddling");

    }

    return jump(V9AnnMCMotel_InviteGuys_MCNotSofa_FoolAroundWithHim, "V9AnnMCMotel_InviteGuys_MCNotSofa_FoolAroundWithHim");

};
export const V9AnnMCMotel_InviteGuys_MCNotSofa_Cuddling = async (): Promise<any> => {
    let dudeOnSofa = tyler;
    let dudeOnBed = mike;
    if (Question.globalAnswers.v9AnnMCMotelGuysInsideWhoSleepSofa === "mike") {
        dudeOnSofa = mike;
        dudeOnBed = tyler;

    }
    ImageClass.setImage(images.v9.V9AnnMCMotel_96);
    await mc.setQuestion(new Question({ text: `...`, options: { think: true }, key: `v9AnnMCMotelCuddlingPlayWithHer` })
        .option({ title: `Play with her`, key: true })
        .option({ title: `Go to sleep`, key: false }));


    if (Question.globalAnswers.v9AnnMCMotelCuddlingPlayWithHer) {
        doWaitImageByTime(v9.V9AnnMCMotel_97);
        mc.think(`How can I not touch her when we are in this position?`);
        doWaitImageByTime(v9.V9AnnMCMotel_98);
        ann.talk(`${mc.name}!`, { method: "Whispering" });
        doWaitImageByTime(v9.V9AnnMCMotel_99);
        ann.talk(`Ahh!`, { method: "Whispering" });
        ImageClass.setImage(v9.V9AnnMCMotel_98);
        ann.talk(`Two can play this game`, { method: "Whispering" });
        ImageClass.setImage(v9.V9AnnMCMotel_100);
        ann.talk(`You clearly don't care that we have two strangers sleeping right here.`, { method: "Whispering" });
        mc.talk(`Judging by your hand, you don't either.`, { method: "Whispering" });
        doWaitImageByTime(v9.V9AnnMCMotel_102);
        ann.talk(`You started it!`, { method: "Whispering" });
        mc.talk(`Do you see me complain?`, { method: "Whispering" });
        doWaitImageByTime(v9.V9AnnMCMotel_101);
        ann.talk(`Oh wow! I didn't realized you are already horny!`, { method: "Whispering" });
        doWaitImageByTime(v9.V9AnnMCMotel_103);
        mc.talk(`Can you really blame me?`, { method: "Whispering" });
        doWaitImageByTime(v9.V9AnnMCMotel_104);
        mc.talk(`Yes! Keep going.`, { method: "Whispering" });
        ImageClass.setImage(images.v9.V9AnnMCMotel_103);
        ann.talk(`Don't you care that they can wake up at any minute?`, { method: "Whispering" });
        doWaitImageByTime(v9.V9AnnMCMotel_105);
        mc.talk(`Right now there is only one thing on my mind.`, { method: "Whispering" });
        ImageClass.setImage(images.v9.V9AnnMCMotel_106);
        ann.talk(`Hehe.`, { method: "Whispering" });
        doWaitImageByTime(v9.V9AnnMCMotel_107);
        mc.talk(`It feels so good!`, { method: "Whispering" });
        doWaitImageByTime(v9.V9AnnMCMotel_108);
        mc.talk(`Use your mouth.`, { method: "Whispering" });
        if (Question.globalAnswers.v9AnnMCMotelDrivingAskedBlowjob) {
            ImageClass.setImage(v9.V9AnnMCMotel_107.partials.V9AnnMCMotel_107_p);
            ann.talk(`Twice in one day.`, { method: "Whispering" });
            ImageClass.setImage(images.v9.V9AnnMCMotel_108);
            mc.talk(`I'll never get tired of it.`, { method: "Whispering" });
        }
        doWaitImageByTime(v9.V9AnnMCMotel_109);
        mc.talk(`Oh fuck yeah.`, { method: "Whispering" });
        doLoopImages([v9.V9AnnMCMotel_110, v9.V9AnnMCMotel_109], 0.6);
        mc.think(`There is no sight of my shy girlfriend anymore.`);
        mc.think(`She is currently sucking my dick while one stranger is on the bed with us and another is sleeping right there across the room.`);
        mc.think(`They can open their eyes and see us at any point.`);
        // FIXME: rolling back twice to this doesn't give the right node
        mc.think(`But it didn't made Ann slow down`);
        doWaitImageByTime(v9.V9AnnMCMotel_111);
        ann.talk(`What do you think?`, { method: "Whispering" });
        doWaitImageByTime(v9.V9AnnMCMotel_112);
        ann.talk(`Should we...?`, { method: "Whispering" });
        mc.talk(`Do you really think I'm going to say no when you are teasing me like that?`, { method: "Whispering" });
        doWaitImageByTime(v9.V9AnnMCMotel_113);
        mc.think(`Ann removed all of her clothes and got on top of me.`);
        mc.think(`My cock slid right inside of her.`);
        doLoopImages([v9.V9AnnMCMotel_114, v9.V9AnnMCMotel_113], 0.7);
        mc.think(`She began riding me causing the bed to shake.`);
        mc.think(`I couldn't help but thinking how ${dudeOnBed.name} would react waking up to people fucking on the same bed he sleeps on.`);
        doLoopImages([v9.V9AnnMCMotel_114, v9.V9AnnMCMotel_113], 0.7);
        mc.think(`Ann! I'm cumming!`);
        // TODO: add options to cum inside her pussy
        await mc.setQuestion(new Question({ text: `Ann! I'm cumming!`, options: { think: false }, key: `v9AnnMCMotelCuddlingPlayWithHerCameOnHerFace` })
            .option({ title: `Pull out`, key: true })
            .option({ title: `Cum inside`, key: false, disabled: true, info: "Will be available for the final version" }));


        if (Question.globalAnswers.v9AnnMCMotelCuddlingPlayWithHerCameOnHerFace) {

        } else {

        }
        doImageShake(v9.V9AnnMCMotel_116);
        mc.talk(`Fuck!`, { method: "Whispering" });
        mc.think(`Damn... That's what you call a bullseye.`);
        doWaitImageByTime(v9.V9AnnMCMotel_117);
        ann.talk(`Wow...`, { method: "Whispering" });
        ann.talk(`I had no idea how exciting it can be when you have a sense of danger someone might catch you.`, { method: "Whispering" });
        if (Question.globalAnswers.v7PhotoShootOutsideConvincedAnnPoseWithOutfit) {
            ann.talk(`The last time I felt something similar was during our photoshoot when someone caught us.`, { method: "Whispering" });
        }
        mc.talk(`You and me both. Look how fast I came.`, { method: "Whispering" });
        ann.talk(`Hehe.`, { method: "Whispering" });
        await ann.setQuestion(new Question({ text: `Now I'm ready to sleep`, options: { think: false, method: "Whispering" }, key: `v9AnnMCMotelCuddlingPlayWithHerKissedHerGoodnight` })
            .option({ title: `Kiss her goodnight`, key: true })
            .option({ title: `Say goodnight`, key: false }));


        mc.talk(`Good night.`, { method: "Whispering" });
        if (Question.globalAnswers.v9AnnMCMotelCuddlingPlayWithHerKissedHerGoodnight) {
            doWaitImageByTime(v9.V9AnnMCMotel_118);
            ann.talk(`Muah!`, { method: "Whispering" });
        }
        // TODO: autoadd without cum on face
        doWaitImageByTime(v9.V9AnnMCMotel_120);
        mc.think(`Now I'm going to sleep like a baby.`);

    }
    // autoadd Mike
    doWaitImageByTime(v9.V9AnnMCMotel_119);
    mc.think(`And that's how the night ended. With a stranger on our bed and Ann safe in my arms.`);

    endReplay(replayScenesList.V9AnnMCMotel_InviteGuys_MCNotSofa);
    return jump(V9AnnMCMotel_Morning, "V9AnnMCMotel_Morning");
};

export const V9AnnMCMotel_InviteGuys_MCNotSofa_FoolAroundWithHim = async (): Promise<any> => {
    let dudeOnSofa = tyler;
    let dudeOnBed = mike;
    if (Question.globalAnswers.v9AnnMCMotelGuysInsideWhoSleepSofa === "mike") {
        dudeOnSofa = mike;
        dudeOnBed = tyler;
    }
    // foolAroundWithHim
    ImageClass.setImage(images.v9.V9AnnMCMotel_12);
    mc.talk(`I doubt he is really asleep.`, { method: "Whispering" });
    ImageClass.setImage(images.v9.V9AnnMCMotel_11);
    ann.talk(`What makes you say that?`, { method: "Whispering" });
    ImageClass.setImage(images.v9.V9AnnMCMotel_12);
    mc.talk(`Do you really think he'd fall asleep that fast when he has a half naked girl sleeping on a bed so close to him?`, { method: "Whispering" });
    ImageClass.setImage(images.v9.V9AnnMCMotel_11);
    ann.talk(`But he knows I'm your girlfriend!`, { method: "Whispering" });
    ImageClass.setImage(images.v9.V9AnnMCMotel_12);
    mc.talk(`Don't you know guys? The fact that he is with you on the same bed he already believes he has a chance.`, { method: "Whispering" });
    ImageClass.setImage(images.v9.V9AnnMCMotel_11);
    ann.talk(`Oh.`, { method: "Whispering" });
    doWaitImageByTime(v9.V9AnnMCMotel_13);
    mc.think(`I knew it.`);
    doWaitImageByTime(v9.V9AnnMCMotel_14);
    mc.think(`Someone just got boner.`);
    doWaitImageByTime(v9.V9AnnMCMotel_15);
    mc.think(`This is going to be interesting...`);
    ImageClass.setImage(v9.V9AnnMCMotel_13);
    mc.talk(`I can prove that he is awake right now.`, { method: "Whispering" });
    ImageClass.setImage(v9.V9AnnMCMotel_13.partials.V9AnnMCMotel_13_p);
    ann.talk(`How?`, { method: "Whispering" });
    mc.talk(`Just look.`, { method: "Whispering" });
    doWaitImageByTime(v9.V9AnnMCMotel_16, { wait: true });
    ImageClass.setImage(v9.V9AnnMCMotel_17);
    ann.talk(`Oh my god!`, { method: "Whispering" });
    ann.talk(`I wonder what got him so excited.`, { method: "Whispering" });
    ImageClass.setImage(v9.V9AnnMCMotel_17.partials.V9AnnMCMotel_17_p);
    ann.talk(`But that still doesn't prove that he is awake...`, { method: "Whispering" });
    ImageClass.setImage(v9.V9AnnMCMotel_18);
    mc.talk(`I see what you are saying...`, { method: "Whispering" });
    mc.talk(`So let's up the stakes.`, { method: "Whispering" });
    mc.talk(`Give it a little kiss see if he open his eyes.`, { method: "Whispering" });
    ImageClass.setImage(images.v9.V9AnnMCMotel_18.partials.V9AnnMCMotel_18_p);
    ann.talk(`Are you serious?`, { method: "Whispering" });
    ImageClass.setImage(images.v9.V9AnnMCMotel_18.partials.V9AnnMCMotel_18_p_2);
    mc.talk(`Why not? You just said he is sleeping.`, { method: "Whispering" });
    mc.talk(`And if he isn't, I'm sure he won't complain.`, { method: "Whispering" });
    ImageClass.setImage(images.v9.V9AnnMCMotel_17);
    ann.talk(`Okay! Let me try!`, { method: "Whispering" });
    doWaitImageByTime(v9.V9AnnMCMotel_20);
    ann.talk(`Muah!`, { method: "Whispering" });
    mc.think(`Ann leaned over and kissed ${dudeOnBed.name}'s cock.`);
    doWaitImageByTime(v9.V9AnnMCMotel_21);
    mc.think(`I could see her perfect round ass as she was doing that.`);
    ImageClass.setImage(v9.V9AnnMCMotel_20);
    mc.think(`I can't lie... Seeing her kissing a stranger cock turned me on.`);
    ImageClass.setImage(v9.V9AnnMCMotel_21);
    mc.think(`Yet he didn't budged.`);
    mc.think(`Is he really asleep? Or he just wanted more?`);

    doWaitImageByTime(v9.V9AnnMCMotel_22);
    ann.talk(`I told you! He is really asleep!`, { method: "Whispering" });
    ann.talk(`Hehe! This is so crazy!`, { method: "Whispering" });
    ImageClass.setImage(images.v9.V9AnnMCMotel_23);
    mc.talk(`Seems like you are enjoying it too much.`, { method: "Whispering" });
    ImageClass.setImage(images.v9.V9AnnMCMotel_22);
    ann.talk(`I like goofing around sometimes.`, { method: "Whispering" });
    ImageClass.setImage(images.v9.V9AnnMCMotel_23);
    mc.talk(`So why stop now?`, { method: "Whispering" });
    mc.talk(`Try licking his tip see if he wakes up.`, { method: "Whispering" });
    ImageClass.setImage(images.v9.V9AnnMCMotel_22);
    ann.talk(`Hehe, Okay!`, { method: "Whispering" });
    doWaitImageByTime(v9.V9AnnMCMotel_24);
    ann.think(`*Lick*`);
    mc.think(`Ann leaned over again and moved her tongue across ${dudeOnBed.name}'s tip.`);
    doImageShake(v9.V9AnnMCMotel_25);
    ann.talk(`Mhmm...?`, { method: "Whispering" });
    ImageClass.setImage(images.v9.V9AnnMCMotel_26);
    ann.talk(`${mc.name}! He woke up!`, { method: "Whispering" });
    ImageClass.setImage(images.v9.V9AnnMCMotel_26.partials.V9AnnMCMotel_26_p);
    ann.talk(`What is he doing now?`, { method: "Whispering" });
    ImageClass.setImage(images.v9.V9AnnMCMotel_26);
    mc.talk(`Looking at you.`, { method: "Whispering" });
    ImageClass.setImage(images.v9.V9AnnMCMotel_26.partials.V9AnnMCMotel_26_p);
    ann.talk(`Oh my...`, { method: "Whispering" });
    ImageClass.setImage(images.v9.V9AnnMCMotel_26);
    mc.talk(`You can't give him blue balls now...`, { method: "Whispering" });
    ImageClass.setImage(images.v9.V9AnnMCMotel_26.partials.V9AnnMCMotel_26_p);
    ann.talk(`I read it's really bad for guys...`, { method: "Whispering" });
    ImageClass.setImage(images.v9.V9AnnMCMotel_26);
    mc.talk(`It does...`, { method: "Whispering" });
    ImageClass.setImage(images.v9.V9AnnMCMotel_26.partials.V9AnnMCMotel_26_p);
    ann.talk(`That would be very mean of me.`, { method: "Whispering" });
    doWaitImageByTime(v9.V9AnnMCMotel_27);
    mc.think(`Ann turned around, but this time got into more comfortable position.`);
    doWaitImageByTime(v9.V9AnnMCMotel_28);
    mc.think(`She put his entire tip inside her mouth.`);
    dudeOnBed.talk(`Ah...`, { method: "Whispering" });
    mc.think(`I watched as my girlfriend started pleasuring a complete stranger when I was right there on the same bed.`);
    doWaitImageByTime(v9.V9AnnMCMotel_30);
    mc.think(`She then started to take the initiative...`);
    doWaitImageByTime(v9.V9AnnMCMotel_29);
    mc.think(`And lower his shorts revealing his cock.`);
    doWaitImageByTime(v9.V9AnnMCMotel_31);
    ann.talk(`Wow...`, { method: "Whispering" });
    doLoopImages([v9.V9AnnMCMotel_287, v9.V9AnnMCMotel_31]);
    mc.think(`She started stroking his cock with both hands.`);
    dudeOnBed.talk(`Fuck... Keep going.`, { method: "Whispering" });
    mc.think(`I trained her well...`);
    doWaitImageByTime(v9.V9AnnMCMotel_68);
    mc.think(`She then stopped and looked at me while putting her hands on the collars of her nightgown.`);
    mc.think(`Is she... Going to undress?`);
    doWaitImageByTime(v9.V9AnnMCMotel_69);
    mc.think(`I couldn't believe she is doing this.`);
    mc.think(`She kept eye contact as she removed her clothes completely.`);
    mc.think(`She was getting ready to be fucked by a stranger yet it felt like she is doing this for me.`);
    doWaitImageByTime(v9.V9AnnMCMotel_72);
    mc.think(`She got up on top of ${dudeOnBed.name} and started riding him.`);
    doLoopImages([v9.V9AnnMCMotel_73, v9.V9AnnMCMotel_72]);
    mc.think(`I kept watching as she was riding him.`);
    mc.think(`I didn't break eye contact as she kept pounding my girl.`);

    // FIXME: ass got bigger for some reason same for V9AnnMCMotel_72.webp V9AnnMCMotel_73.webp
    doWaitImageByTime(v9.V9AnnMCMotel_71);
    doLoopImages([v9.V9AnnMCMotel_70, v9.V9AnnMCMotel_71]);
    mc.think(`Then, for a few moments, Ann let herself focus only on herself.`);
    mc.think(`She tried to keep up with ${dudeOnBed.name}'s speed.`);
    doWaitImageByTime(v9.V9AnnMCMotel_74);
    mc.think(`${dudeOnBed.name} set up on the bed while picking up Ann let she was weight nothing.`);
    doLoopImages([v9.V9AnnMCMotel_280, v9.V9AnnMCMotel_74]);
    mc.think(`She didn't forget about me. She wanted to see if I'm watching.`);
    mc.think(`And I did.`);
    mc.think(`I watched has Ann's pussy is making ${dudeOnBed.name} reaching climax.`);
    doWaitImageByTime(v9.V9AnnMCMotel_75);
    dudeOnBed.talk(`Ahhh!`, { method: "Whispering" });
    doWaitImageByTime(v9.V9AnnMCMotel_76);
    mc.think(`It's done.`);
    mc.think(`${dudeOnBed.name} just came inside my girlfriend filling her up with his cum.`);

    doWaitImageByTime(v9.V9AnnMCMotel_77);
    // TODO: render expressions for text below
    dudeOnBed.talk(`Damn.`, { method: "Whispering" });
    ImageClass.setImage(images.v9.V9AnnMCMotel_78.partials.V9AnnMCMotel_281_p, { putParent: true });
    ann.talk(`Hehe.`, { method: "Whispering" });
    ImageClass.setImage(images.v9.V9AnnMCMotel_77);
    dudeOnBed.talk(`I'll be honest. You definitely surprised me. I didn't expect that to happen at all.`, { method: "Whispering" });
    ann.talk(`Oh.`, { method: "Whispering" });
    ImageClass.setImage(images.v9.V9AnnMCMotel_282);
    dudeOnBed.talk(`But I'm glad it did.`, { method: "Whispering" });
    ImageClass.setImage(images.v9.V9AnnMCMotel_283);
    dudeOnBed.talk(`But now I feel a bit bad...`, { method: "Whispering" });
    ImageClass.setImage(images.v9.V9AnnMCMotel_78.partials.V9AnnMCMotel_284_p, { putParent: true });
    ann.talk(`Oh! Why?`, { method: "Whispering" });
    ImageClass.setImage(v9.V9AnnMCMotel_79);
    dudeOnBed.talk(`Because of my boy over there.`, { method: "Whispering" });
    dudeOnBed.talk(`Not only he sleeps alone on the sofa he also missed out on some fun...`, { method: "Whispering" });
    doWaitImageByTime(v9.V9AnnMCMotel_77);
    dudeOnBed.talk(`It might sound rude, but would you be willing to help him out?`, { method: "Whispering" });
    dudeOnBed.talk(`I'm sure he would appreciate it.`, { method: "Whispering" });

    ImageClass.setImage(v9.V9AnnMCMotel_78);
    ann.talk(`What do you want me to do?`, { method: "Whispering" });
    ImageClass.setImage(images.v9.V9AnnMCMotel_283);
    dudeOnBed.talk(`Nothing too serious, even a handy would work.`, { method: "Whispering" });
    ImageClass.setImage(v9.V9AnnMCMotel_78);
    ann.talk(`Oh...`, { method: "Whispering" });

    if (Question.globalAnswers.V1NtrUnexpected) {
        ImageClass.setImage(images.v9.V9AnnMCMotel_78.partials.V9AnnMCMotel_285_p);
        ann.talk(`Yes. I can do that.`, { method: "Whispering" });
        doWaitImageByTime(v9.V9AnnMCMotel_77);
        dudeOnBed.talk(`Excellent! He would love that.`, { method: "Whispering" });


    } else {
        ImageClass.setImage(v9.V9AnnMCMotel_78);
        ann.talk(`I don't know... I'll have to ask my boyfriend...`, { method: "Whispering" });
        dudeOnBed.talk(`Of course.`, { method: "Whispering" });
        ImageClass.setImage(v9.V9AnnMCMotel_89);
        await ann.setQuestion(new Question({ text: `What do you say?`, options: { think: false }, key: `v9AnnMCMotelBlowjobToGuyOnSofa` })
            .option({ title: `Agree`, key: true })
            .option({ title: `Don't agree`, key: false }));


        if (Question.globalAnswers.v9AnnMCMotelBlowjobToGuyOnSofa) {
            mc.talk(`Go ahead. He already got the short end of the stick by sleeping on the sofa.`, { method: "Whispering" });
            mc.talk(`That's the least we can do for him.`, { method: "Whispering" });

        } else {
            mc.talk(`I think we should call it a day. Let's just go to sleep.`, { method: "Whispering" });
            ImageClass.setImage(v9.V9AnnMCMotel_78.partials.V9AnnMCMotel_286_p, { putParent: true });
            ann.talk(`Sorry. I can't.`, { method: "Whispering" });
            ImageClass.setImage(v9.V9AnnMCMotel_283);
            dudeOnBed.talk(`Damn... He'll kill me if he finds out.`, { method: "Whispering" });
            dudeOnBed.talk(`But I had to ask right?`, { method: "Whispering" });
            ImageClass.setImage(v9.V9AnnMCMotel_78.partials.V9AnnMCMotel_286_p, { putParent: true });
            ann.talk(`Yeah... Sorry...`, { method: "Whispering" });

        }

    }
    if (Question.globalAnswers.v9AnnMCMotelBlowjobToGuyOnSofa || Question.globalAnswers.V1NtrUnexpected) {
        doWaitImageByTime(v9.V9AnnMCMotel_80);
        mc.think(`Ann walked over to ${dudeOnSofa.name} and reached her hand down his shorts.`);
        mc.think(`This time she wasn't scared what he might think.`);
        mc.think(`You could tell she already gained confidence by just fucking ${dudeOnBed.name}.`);
        doWaitImageByTime(v9.V9AnnMCMotel_81);
        mc.think(`You could tell she was surprised by his size and the fact that he was already ready for her.`);
        doWaitImageByTime(v9.V9AnnMCMotel_82);
        mc.think(`She grabbed his cock with two hands and started stroking his.`);
        doLoopImages([v9.V9AnnMCMotel_83, v9.V9AnnMCMotel_82], 0.5);
        mc.think(`She kept massaging his cock up and down.`);
        mc.think(`${dudeOnSofa.name} was clearly awake but kept his eyes closed enjoying every bit of Ann's hands.`);
        doWaitImageByTime(v9.V9AnnMCMotel_84);
        mc.think(`Then, without warning, he exploded. Covered all her hands with his cum.`);
        doWaitImageByTime(v9.V9AnnMCMotel_85);
        mc.think(`I wasn't expecting that.`);
        mc.think(`She licked his cock up and down licking some of his cum off his shaft.`);
        doWaitImageByTime(v9.V9AnnMCMotel_86);
        mc.think(`She licked every bit of it making sure nothing goes to waste.`);
        // TODO: finish from here -> Add ->if kissed after kiss cum + unexpected have her kissing him. ->

    }




    // TODO: add the cum on mouth after the 
    doWaitImageByTime(v9.V9AnnMCMotel_90);
    ann.talk(`Now I'll definitely won't have problem fall asleep.`);
    doWaitImageByTime(v9.V9AnnMCMotel_88);
    ann.talk(`I love you so much.`);
    doWaitImageByTime(v9.V9AnnMCMotel_90);
    await mc.setQuestion(new Question({ text: `I love you too.`, options: { think: false }, key: `v9AnnMCMotelKissedHerGoodnight` })
        .option({ title: `Kiss her good night`, key: true })
        .option({ title: `Say good night`, key: false }));

    if (Question.globalAnswers.v9AnnMCMotelKissedHerGoodnight) {
        doWaitImageByTime(v9.V9AnnMCMotel_91);
        // TODO: mention if kissed Chris and if unexpected + chris she'll kiss him without asking
        ann.talk(`Muah!`);
        if (Question.globalAnswers.v9AnnMCMotelBlowjobToGuyOnSofa || Question.globalAnswers.V1NtrUnexpected) {
            doWaitImageByTime(v9.V9AnnMCMotel_93);
            mc.think(`As I kissed Ann goodnight I could taste more than her saliva.`);
            mc.think(`But I didn't care.`);
        }
    } else {
        mc.talk(`Good night!`);
    }

    doWaitImageByTime(v9.V9AnnMCMotel_94);
    mc.think(`And that's how the night ended.`);
    mc.think(`With Ann in my arms. Happy and satisfied.`);
    endReplay(replayScenesList.V9AnnMCMotel_InviteGuys_MCNotSofa);
    return jump(V9AnnMCMotel_Morning, "V9AnnMCMotel_Morning");
};
export const V9AnnMCMotel_InviteGuys_MCNotSofa_MCSleeping = async (): Promise<any> => {
    let dudeOnSofa = tyler;
    let dudeOnBed = mike;
    if (Question.globalAnswers.v9AnnMCMotelGuysInsideWhoSleepSofa === "mike") {
        dudeOnSofa = mike;
        dudeOnBed = tyler;
    }

    // ImageClass.setImage(v9.V9AnnMCMotel_9);
    // mc.think(`I wasn't completely sure what I was trying to achieve.`);
    // mc.think(`But something inside of me told me to stay put and see what happens.`);
    // mc.think(`And I was quick to find out.`);
    // doWaitImageByTime(v9.V9AnnMCMotel_8);
    // mc.think(`${dudeOnBed.name} turned to the side and started cuddling with Ann.`);
    // if (dudeOnBed.name === tyler.name) {
    //     mc.think(`To his defense, he did say he is a hugger.`);
    // }

    // mc.think(`With one eye barely open I could see how my girlfriend finds comfort in some stranger's arms.`);
    // mc.think(`While I'm on the same bed.`);
    doWaitImageByTime(images.v2_5.BlackScreen);
    empty.think(`If you see this, there is either a bug, or you cheated your way here 😜, this will only be available after the alpha 😉.`);

    endReplay(replayScenesList.V9AnnMCMotel_InviteGuys_MCNotSofa);
    //TODO: finish this scene and remove this jump after the alpha.
    return jump(V9AnnMCMotel_InviteGuys_MCNotSofa, "V9AnnMCMotel_InviteGuys_MCNotSofa");





    return jump(V9AnnMCMotel_Morning, "V9AnnMCMotel_Morning");
};

export const V9AnnMCMotel_Alone = async (): Promise<any> => {
    ImageClass.setImage(images.v9.V9AnnMCMotel_124);
    mc.think(`Ann is looking sexy as hell in this nightgown...`);
    mc.think(`It's been a long drive but I still have some energy for some sexy time.`);
    mc.think(`The last time, out of nowhere, she wanted to be roughed up.\nI could do that.`);
    await mc.setQuestion(new Question({ text: `Or maybe it's time for some sweet love making?`, options: { think: true }, key: `v9AnnMCMotelAloneChoices` })
        .option({ title: `Have passionate sex`, key: `passionateSex` })
        .option({ title: `Rough sex`, key: `roughSex` })
        .option({ title: `Just go to sleep`, key: `gotoSleep` }));




    if (Question.globalAnswers.v9AnnMCMotelAloneChoices === "passionateSex") {
        return jump(V9AnnMCMotel_Alone_Passionate, "V9AnnMCMotel_Alone_Passionate");




    } else if (Question.globalAnswers.v9AnnMCMotelAloneChoices === "roughSex") {
        return jump(V9AnnMCMotel_Alone_Rough, "V9AnnMCMotel_Alone_Rough");


    }


    return jump(V9AnnMCMotel_Alone_2, "V9AnnMCMotel_Alone_2");
};
export const V9AnnMCMotel_Alone_Passionate = async (): Promise<any> => {
    ImageClass.setImage(images.v9.V9AnnMCMotel_124);
    mc.talk(`When I think of it. It's been a while since we spent a full night together.`);
    mc.talk(`Last time was at Joey's birthday party.`);
    ImageClass.setImage(images.v9.V9AnnMCMotel_183);
    ann.talk(`Wow, you are right!`);

    doWaitImageByTime(v9.V9AnnMCMotel_127);
    mc.talk(`We are about to make up to here right now.`);
    doWaitImageByTime(v9.V9AnnMCMotel_126);
    mc.talk(`You are so hot. I'm the luckiest person alive.`);
    doWaitImageByTime(v9.V9AnnMCMotel_129);
    mc.think(`Ann was standing in front of my wearing just her panties.`);
    doWaitImageByTime(v9.V9AnnMCMotel_128);
    mc.think(`I looked down admiring her body that just waited to be touched.`);
    doWaitImageByTime(v9.V9AnnMCMotel_250);
    mc.think(`I reached my hand down her panties and started rubbing her pussy.`);
    doWaitImageByTime(v9.V9AnnMCMotel_251);
    mc.think(`Ann was already moist as I started rubbing my fingers against her clit.`);
    doWaitImageByTime(v9.V9AnnMCMotel_252);
    mc.think(`I lay her down on the bed and started licking her pussy.`);
    doWaitImageByTime(v9.V9AnnMCMotel_253);
    mc.think(`As Ann was moaning I push my tongue further and further inside her vagina licking every bit of her.`);
    ann.talk(`Ahh... ${mc.name}.`);
    doWaitImageByTime(v9.V9AnnMCMotel_252);
    mc.think(`It felt good hearing her calling my name.`);
    mc.think(`I didn't ask for a blowjob this time.`);
    mc.think(`I wanted to enter her while she is this wet.`);
    doWaitImageByTime(v9.V9AnnMCMotel_162);
    mc.think(`My dick slipped right inside as I went on top of her.`);
    doWaitImageByTime(v9.V9AnnMCMotel_163);
    mc.think(`We both kept kissing passionately while our body were in sync.`);
    doWaitImageByTime(v9.V9AnnMCMotel_254);
    ann.talk(`Ahh...`);
    doWaitImageByTime(v9.V9AnnMCMotel_255);
    mc.think(`I position myself behind Ann gaining access to her vagina.`);
    mc.think(`We both kept kissing while I kept fucking her from behind.`);
    doWaitImageByTime(v9.V9AnnMCMotel_256);
    mc.think(`Because her legs where closed her pussy fast even more tighter than usual.`);
    // doWaitImageByTime(v9.V9AnnMCMotel_257);
    doLoopImages([v9.V9AnnMCMotel_257, v9.V9AnnMCMotel_256], 1.5, 1.5);
    await mc.setQuestion(new Question({ text: `It felt so I good I couldn't stand it anymore.`, options: { think: true }, key: `v9AnnMCMotelAloneCameOnHerFace` })
        .option({ title: `Cum on her face`, key: true })
        .option({ title: `Creampie`, key: false }));

    mc.think(`Her tight pussy was too much for me.`);
    mc.talk(`I'm cumming!`);
    ann.talk(`No... Please... I'm so close!`);

    if (Question.globalAnswers.v9AnnMCMotelAloneCameOnHerFace) {
        mc.think(`I had to pull out.`);
        doImageShake(v9.V9AnnMCMotel_259, { wait: 1.2 });
        doWaitImageByTime(v9.V9AnnMCMotel_260);
        mc.think(`I wanted to cum all over her sweet face.`);

    } else {
        doImageShake(v9.V9AnnMCMotel_258);
        mc.talk(`Ahhh!!!`);
    }
    return jump(V9AnnMCMotel_Alone_2, "V9AnnMCMotel_Alone_2");
};
export const V9AnnMCMotel_Alone_Rough = async (): Promise<any> => {
    ImageClass.setImage(images.v9.V9AnnMCMotel_124);
    mc.think(`I knew she wanted it and I decided to give her what she wants.`);
    doWaitImageByTime(v9.V9AnnMCMotel_125);
    ann.talk(`Ahh!`);
    mc.talk(`Is this what you want?`);
    ann.talk(`Yes.`);
    doWaitImageByTime(v9.V9AnnMCMotel_127);
    mc.talk(`If you want to stop, just say stop.`);
    doWaitImageByTime(v9.V9AnnMCMotel_129);
    mc.think(`I had no doubt Ann wants this. But I still wanted to establish a safe word so she'll still feel safe.`);
    doWaitImageByTime(v9.V9AnnMCMotel_128);
    mc.think(`I looked down at her naked hot body and was ready to do with it as I see fit.`);
    doWaitImageByTime(v9.V9AnnMCMotel_130);
    mc.think(`Ann kneeled in front of me and I grabbed her head as she wrapped her lips around my cock.`);
    doWaitImageByTime(v9.V9AnnMCMotel_131);
    mc.think(`She didn't resist.`);
    doWaitImageByTime(v9.V9AnnMCMotel_132.partials.V9AnnMCMotel_132_p, { putParent: true });
    mc.think(`I started moving her mouth slowly deep inside my throat.`);
    ImageClass.setImage(v9.V9AnnMCMotel_131);
    mc.think(`I could feel my dick reaching her throat but still not sliding inside.`);
    doWaitImageByTime(v9.V9AnnMCMotel_132.partials.V9AnnMCMotel_132_p, { putParent: true });
    mc.think(`I tried again but this time I held my hands in place.`);
    ImageClass.setImage(v9.V9AnnMCMotel_132);
    ann.talk(`*COUGH*`);
    mc.think(`Ann coughed and drooled all over my cock.`);
    doWaitImageByTime(v9.V9AnnMCMotel_131.partials.V9AnnMCMotel_131_p, { putParent: true });
    mc.think(`I gave her some time to breath before continuing.`);
    doLoopImages([v9.V9AnnMCMotel_132, { ...v9.V9AnnMCMotel_131.partials.V9AnnMCMotel_131_p, options: { putParent: true } }]);
    mc.think(`I kept moving her head back and fourth as she started to drool all over my cock.`);
    doWaitImageByTime(v9.V9AnnMCMotel_135);
    mc.think(`She started to tearing up ruining her mascara.`);
    mc.think(`I looked down at her watching her kneeling there. So submissive, with my cock in her mouth.`);
    doWaitImageByTime(v9.V9AnnMCMotel_134);
    mc.think(`I held her head allowing her to catch her breath once more.`);
    doWaitImageByTime(v9.V9AnnMCMotel_136);
    mc.think(`I started to push her head slowly making sure my cock fits inside her throat.`);
    ImageClass.setImage(v9.V9AnnMCMotel_137);
    mc.think(`Then I strongly pushed it all the way down.`);
    mc.think(`I felt so good as it curved inside her throat.`);
    ImageClass.setImage(v9.V9AnnMCMotel_138);
    mc.think(`I took her head out and looked at her.`);
    mc.think(`She didn't tell me to stop.`);
    doImageShake(v9.V9AnnMCMotel_137);
    mc.think(`Without warning I forced my cock down her throat again.`);
    mc.think(`Her throat was already ready for me as it was even easier to slid it down. `);
    mc.think(`I held her down there for a few seconds.`);
    doWaitImageByTime(v9.V9AnnMCMotel_133);
    ann.talk(`Slurp.`);
    mc.think(`Her saliva exploded out of her throat as she was trying to catch her breath once more.`);
    doWaitImageByTime(v9.V9AnnMCMotel_147);
    mc.think(`I grabbed Ann's hand and started fucking her from behind.`);
    doWaitImageByTime(v9.V9AnnMCMotel_148);
    mc.think(`I held her so tight she wasn't able to move.`);
    doWaitImageByTime(v9.V9AnnMCMotel_149);
    ann.talk(`Oh my god!`);
    doWaitImageByTime(v9.V9AnnMCMotel_150);
    mc.think(`She began to moan harder and harder each time I entered her.`);
    doLoopImages([v9.V9AnnMCMotel_152, v9.V9AnnMCMotel_153]);
    ann.talk(`${mc.name}!`);
    mc.think(`For a second I thought she is telling me to stop.`);
    mc.think(`But all she wanted is me to keep going.`);
    doWaitImageByTime(v9.V9AnnMCMotel_151);
    ann.talk(`Ahh!`);
    doWaitImageByTime(v9.V9AnnMCMotel_143);
    mc.think(`I pushed her against the the motel door and kept fucking her from behind.`);
    doWaitImageByTime(v9.V9AnnMCMotel_146);
    mc.think(`As my body was filled with adrenaline I had no intention of slowing down.`);
    ImageClass.setImage(v9.V9AnnMCMotel_145);
    ann.talk(`Ah!`);
    mc.think(`I grabbed Ann's hair pushing her harder against me.`);
    ImageClass.setImage(v9.V9AnnMCMotel_144);
    mc.think(`I kept pushing, grabbing harder and harder. Yet she didn't say the safe word.`);
    mc.think(`She loved every minute of it.`);
    doWaitImageByTime(v9.V9AnnMCMotel_140);
    mc.think(`I threw her on the bed and penetrated her while looking her in the eyes.`);
    doWaitImageByTime(v9.V9AnnMCMotel_141);
    mc.think(`She kept eye contact as I kept entering her back and fourth.`);
    doWaitImageByTime(v9.V9AnnMCMotel_294);
    mc.think(`Watching her lying there, so submissive, with the mascara dripping down her face turned me on even more.`);
    doLoopImages([v9.V9AnnMCMotel_140, v9.V9AnnMCMotel_142]);
    await mc.setQuestion(new Question({ text: `I'm getting close!`, options: { think: true }, key: `v9AnnMCMotelAloneRoughFuckChoices` })
        .option({ title: `Cum inside her pussy`, key: `cumPussy` })
        .option({ title: `Cum inside her ass`, key: `cumAss` })
        .option({ title: `Cum on her face`, key: `cumFace` }));


    if (Question.globalAnswers.v9AnnMCMotelAloneRoughFuckChoices === "cumPussy") {
        mc.think(`I couldn't held myself any longer!`);
        mc.talk(`I'm cumming!`);
        doImageShake(v9.V9AnnMCMotel_293);
        mc.talk(`Ahh!!!`);


    } else if (Question.globalAnswers.v9AnnMCMotelAloneRoughFuckChoices === "cumAss") {
        mc.think(`But I wasn't done just yet.`);
        if (isAnnDidAnalWithChris() && !isAnnDidAnalWithMC()) {
            mc.think(`Chris had the chance to try and fuck Ann in the ass. But now it's my time.`);

        } else if (isAnnDidAnalWithMC()) {
            mc.think(`Last time I couldn't fit my cock all the way down her ass, but I felt like now it's the perfect time to try again.`);

        } else {
            mc.think(`I wanted to feel her ass before I do.`);
        }
        doWaitImageByTime(v9.V9AnnMCMotel_156);
        mc.think(`I positioned myself behind Ann and inserted the tip of my cock inside her ass.`);
        doImageShake(v9.V9AnnMCMotel_155);
        ann.talk(`Fuck!`);
        doLoopImages([v9.V9AnnMCMotel_156, v9.V9AnnMCMotel_155]);
        mc.think(`I kept fucking her harder and harder.`);
        mc.think(`Her tight her kept squeezing my cock tighter and tigher.`);
        doWaitImageByTime(v9.V9AnnMCMotel_154);
        mc.think(`I kept chocking her as I kept ramming her ass.`);
        mc.talk(`I'm cumming!`);
        doImageShake(v9.V9AnnMCMotel_157);
        mc.talk(`Fuck.`);
        doWaitImageByTime(v9.V9AnnMCMotel_158);
        mc.think(`As I took my cock outside her ass I could feel all my cum spilling from her ass.`);

    } else {
        mc.think(`I was ready to cum.`);
        mc.think(`I wanted to see her pretty face covered with my cum.`);
        doImageShake(v9.V9AnnMCMotel_159, { wait: 1 });
        ImageClass.setImage(images.v9.V9AnnMCMotel_160, { wait: true });
    }


    if (Question.globalAnswers.v9AnnMCMotelAloneRoughFuckChoices !== "cumAss") {
        doWaitImageByTime(v9.V9AnnMCMotel_294);
        if (Question.globalAnswers.v9AnnMCMotelAloneRoughFuckChoices === "cumFace") {
            mc.think(`She looked at me with her face covered with cum and dripping mascara.`);

        } else {
            mc.think(`Ann looked at me.\nWe both had a few moments to catch out breath.`);

        }

    } else {
        mc.think(`We both had a few moments to catch out breath.`);

    }
    return jump(V9AnnMCMotel_Alone_2, "V9AnnMCMotel_Alone_2");
};

export const V9AnnMCMotel_Alone_2 = async (): Promise<any> => {
    // if had sex
    if (Question.globalAnswers.v9AnnMCMotelAloneChoices !== "gotoSleep") {
        await mc.setQuestion(new Question({ text: Question.globalAnswers.v9AnnMCMotelAloneChoices === "passionateSex" ? `Ann didn't cum yet...` : `I'm not sure if Ann came.`, options: { think: true }, key: `v9AnnMCMotelAloneKeepFuckingAfterCumChoices` })
            .option({ title: `Keep fucking (while kissing)`, key: "keepFuckingKissing" })
            .option({ title: `Lick her pussy`, key: "LickHerPussy" })
            .option({ title: `Go to sleep`, key: "GotoSleep" }));


        if (Question.globalAnswers.v9AnnMCMotelAloneChoices === "passionateSex") {
            mc.think(`Ann was close yet didn't cum.`);
            if (Question.globalAnswers.v9AnnMCMotelAloneKeepFuckingAfterCumChoices !== "GotoSleep") {
                mc.think(`I couldn't be selfish.`);
            } else {
                mc.think(`But I was too tired.`);
            }
        } else {
            mc.think(`I gave her what she wanted physically but now it's time to show her some passion.`);
        }

        if (Question.globalAnswers.v9AnnMCMotelAloneKeepFuckingAfterCumChoices === "keepFuckingKissing") {
            mc.think(`Even though I came already, I pushed my cock back inside her pussy.`);
            // autoadd V9AnnMCMotel_261, V9AnnMCMotel_164, V9AnnMCMotel_164_p
            doWaitImageByTime(v9.V9AnnMCMotel_163);
            if (Question.globalAnswers.v9AnnMCMotelAloneCameOnHerFace || Question.globalAnswers.v9AnnMCMotelAloneRoughFuckChoices === "cumFace") {

                if (Question.globalAnswers.v9AnnMCMotelAloneChoices === "passionateSex") {
                    mc.think(`It didn't bothered me that I just came on her face, all I care was making her cum as well.`);
                } else {
                    mc.think(`It didn't bothered me that I just came on her face, I just wanted to feel her lips.`);
                }

            } else if (Question.globalAnswers.v9AnnMCMotelAloneChoices === "passionateSex"
                || (Question.globalAnswers.v9AnnMCMotelAloneChoices === "roughSex" && Question.globalAnswers.v9AnnMCMotelAloneRoughFuckChoices === "cumPussy")) {
                mc.think(`It felt a bit different.`);
                mc.think(`I could feel I just came inside of her.\nBut I was just focused on making her cum.`);
            }
            // autoadd V9AnnMCMotel_262, V9AnnMCMotel_254, V9AnnMCMotel_254_p
            doLoopImages([v9.V9AnnMCMotel_254, v9.V9AnnMCMotel_163,]);
            mc.think(`We kept fucking for a few more minute.`);
            // V9AnnMCMotel_263, V9AnnMCMotel_264_p, V9AnnMCMotel_264_p_2
            ImageClass.setImage(v9.V9AnnMCMotel_264);
            ann.talk(`Ahh!!!`);

        } else if (Question.globalAnswers.v9AnnMCMotelAloneKeepFuckingAfterCumChoices === "LickHerPussy") {
            // autoadd V9AnnMCMotel_265 - face
            // autoadd V9AnnMCMotel_266 - pussy
            // V9AnnMCMotel_252_p ,V9AnnMCMotel_252_p_2
            doWaitImageByTime(v9.V9AnnMCMotel_252);
            mc.think(`I decided to go down on her again.`);
            // autoadd V9AnnMCMotel_267 - face
            // autoadd V9AnnMCMotel_268 - pussy
            // V9AnnMCMotel_253_p, V9AnnMCMotel_253_p_2
            doWaitImageByTime(v9.V9AnnMCMotel_253);
            if (Question.globalAnswers.v9AnnMCMotelAloneCameOnHerFace || Question.globalAnswers.v9AnnMCMotelAloneRoughFuckChoices === "cumFace") {
                mc.think(`It was hot seeing my cum dripping off her face while I ate her heart out.`);
            } else {
                mc.think(`I kept licking and eating every bit of her.`);
                if (Question.globalAnswers.v9AnnMCMotelAloneRoughFuckChoices === "cumAss") {
                    mc.think(`I just came in her ass.`);
                } else {
                    mc.think(`I can feel that the taste is different.`);
                    mc.think(`It was a mixture of her pussy juice with my own cum.`);
                }
                ImageClass.setImage(v9.V9AnnMCMotel_252);
                mc.think(`But it didn't deter me at all.`);
                ImageClass.setImage(v9.V9AnnMCMotel_253);
                mc.think(`My only focus was making Ann feel good.`);

            }
            mc.think(`I kept licking and licking until...`);
            // autoadd 270 for face. 269 - pus, 270_p, 270_p_2
            ImageClass.setImage(v9.V9AnnMCMotel_270_2);
            ann.talk(`Ahh!!!`);
            ann.talk(`Oh my god!`);

        }

        if (Question.globalAnswers.v9AnnMCMotelAloneKeepFuckingAfterCumChoices !== "GotoSleep") {
            // autoadd face 272
            doWaitImageByTime(v9.V9AnnMCMotel_271, null, 1.5);
            ann.talk(`I love you so much.`);
            await mc.setQuestion(new Question({ text: `I love you too.`, options: { think: false }, key: `v9AnnMCMotelKissedHerGoodnight` })
                .option({ title: `Kiss her good night`, key: true })
                .option({ title: `Say good night`, key: false }));

            if (Question.globalAnswers.v9AnnMCMotelKissedHerGoodnight) {
                doWaitImageByTime(v9.V9AnnMCMotel_273);
                ann.talk(`Muah!`);

            } else {
                mc.talk(`Good night!`);
            }

        }
    }


    // autoadd V9AnnMCMotel_275, V9AnnMCMotel_276, V9AnnMCMotel_277
    doWaitImageByTime(v9.V9AnnMCMotel_278);
    // gotoSleep

    if (Question.globalAnswers.v9AnnMCMotelAloneChoices !== "gotoSleep") {
        mc.think(`And that's how the night ended.`);
        mc.think(`Time to sleep.`);

    } else {

        mc.talk(`Let's call it a day. I'm tired from the drive.`);
        ann.talk(`Okay.`);
    }

    if (Question.globalAnswers.v9AnnMCMotelAloneChoices === "passionateSex") {
        endReplay(replayScenesList.V9AnnMCMotel_Alone_Passionate);
    } else if (Question.globalAnswers.v9AnnMCMotelAloneChoices === "roughSex") {
        endReplay(replayScenesList.V9AnnMCMotel_Alone_Rough);
    }

    return jump(V9AnnMCMotel_Morning, "V9AnnMCMotel_Morning");
};


export const V9AnnMCMotel_Morning = async (): Promise<any> => {
    // safeguard
    endReplay();
    // TODO: change for Ann hate
    //autoadd V9AnnMCMotelDriving_48
    doTransition(v9.V9AnnMCMotelDriving_38, null, 2);
    ann.talk(`Good morning!`);

    if (Question.globalAnswers.v9AnnMCMotelInviteGuysInside || Question.globalAnswers.v9AnnMCMotelAloneOptions === "roughSex" || Question.globalAnswers.v9AnnMCMotelAloneOptions === "passionateSex") {

        // autoadd V9AnnMCMotelDriving_49
        doWaitImageByTime(v9.V9AnnMCMotelDriving_50);
        mc.talk(`Good morning.`);
        if (Question.globalAnswers.v9AnnMCMotelInviteGuysInside) {
            // autoadd V9AnnMCMotelDriving_51
            ImageClass.setImage(v9.V9AnnMCMotelDriving_41);
            mc.talk(`I didn't even hear the guys leaving.`);
            ImageClass.setImage(v9.V9AnnMCMotelDriving_43);
            ann.talk(`Yeah, you were sleeping like a rock!`);
            mc.talk(`Seems that way.`);
        } else {
            doWaitImageByTime(v9.V9AnnMCMotelDriving_43);
            mc.talk(`How did you sleep?`);
        }

        ImageClass.setImage(v9.V9AnnMCMotelDriving_43);
        ann.talk(`Surprisingly well! I wasn't sure I would be able to fall asleep.`);
        if (Question.globalAnswers.v9AnnMCMotelGuysInsideWhoSleepSofa === "mc") {
            ImageClass.setImage(v9.V9AnnMCMotelDriving_45);
            mc.talk(`After yesterday, I bet you were exhausted.`);
            ImageClass.setImage(v9.V9AnnMCMotelDriving_46);
            ann.talk(`Hehe... Those guys kept me busy...`);
            ImageClass.setImage(v9.V9AnnMCMotelDriving_47);
            ann.talk(`And they said they were tired...`);
            // Happened but MC not on the sofa
        } else if (Question.globalAnswers.v9AnnMCMotelCuddlingPlayWithHer) {
            mc.talk(`After yesterday, I bet you were exhausted.`);
            ImageClass.setImage(v9.V9AnnMCMotelDriving_46);
            ann.talk(`Hehe, yes you made sure I'll get a good night sleep.`);

        } else if (Question.globalAnswers.v9AnnMCMotelCuddlingPlayWithHer === false) {
            ImageClass.setImage(images.v9.V9AnnMCMotelDriving_47);
            ann.talk(`Especially with the guys being here and all.`);
            ImageClass.setImage(v9.V9AnnMCMotelDriving_46);
            ann.talk(`But you kept me safe!`);
            ImageClass.setImage(v9.V9AnnMCMotelDriving_45);
            mc.talk(`I'm always here for you.`);
            ImageClass.setImage(v9.V9AnnMCMotelDriving_46);
            ann.talk(`Hehe.`);


        } else if (Question.globalAnswers.v9AnnMCMotelGuysInsideWhoSleepSofa) {
            let dudeName = tyler.name;
            if (Question.globalAnswers.v9AnnMCMotelGuysInsideWhoSleepSofa === "mike") {
                dudeName = mike.name;
            }
            ImageClass.setImage(v9.V9AnnMCMotelDriving_46);
            ann.talk(`Hehe... ${dudeName} kept me busy...`);
            ImageClass.setImage(v9.V9AnnMCMotelDriving_47);
            ann.talk(`And I thought he was tired...`);
            ImageClass.setImage(v9.V9AnnMCMotelDriving_45);
            mc.talk(`Even if he was, no one can resist you.`);
            ImageClass.setImage(v9.V9AnnMCMotelDriving_46);
            ann.talk(`Hehe!`);
        }
    } else {
        doWaitImageByTime(v9.V9AnnMCMotelDriving_50.partials.V9AnnMCMotelDriving_49);
        mc.talk(`Good morning.`);
        mc.talk(`How did you sleep?`);
        ImageClass.setImage(images.v9.V9AnnMCMotelDriving_43);
        ann.talk(`Surprisingly well! I wasn't sure I would be able to fall asleep.`);
        ImageClass.setImage(images.v9.V9AnnMCMotelDriving_45);
        mc.talk(`So you didn't hear the burglar?`);
        ImageClass.setImage(images.v9.V9AnnMCMotelDriving_52);
        ann.talk(`${mc.name}! Don't scare me!`);
        mc.talk(`Haha. Let's head out.`);
    }

    ImageClass.setImage(images.v9.V9AnnMCMotelDriving_45);
    mc.talk(`I think we should get going. I already overslept.`);
    ImageClass.setImage(images.v9.V9AnnMCMotelDriving_43);
    ann.talk(`I agree. Let's go!`);

    if (Question.globalAnswers.v9AnnMCMotelInviteGuysInside) {
        return jump(V9AnnMCMotel_Morning_GuysOutside, "V9AnnMCMotel_Morning_GuysOutside");
    }


    doWaitImageByTime(v9.V9AnnMCMotelDriving_25);
    mc.talk(`We should be there in a few hours.`);
    return jump(V9AnnMCMotel_End, "V9AnnMCMotel_End");

};
export const V9AnnMCMotel_Morning_GuysOutside = async (): Promise<any> => {
    doTransition(v9.V9AnnMCMotelDriving_25);
    mc.talk(`We should be there in a few hours.`);
    tyler.talk(`I think we are going to die here!`, { method: "Shouting" });
    doWaitImageByTime(v9.V9AnnMCMotelDriving_26);
    mc.talk(`Huh?`);
    doWaitImageByTime(v9.V9AnnMCMotelDriving_27);
    tyler.talk(`Man! No one stops for me!`);
    mike.talk(`Stop crying!`);
    ImageClass.setImage(images.v9.V9AnnMCMotelDriving_28);
    tyler.talk(`Bro, you know exactly why people aren't stopping for me.`);
    ImageClass.setImage(images.v9.V9AnnMCMotelDriving_29);
    mike.talk(`Oh no, you aren't going to pull that card on me now!`);
    mike.talk(`Don't be a lazy fuck! It's your turn now.`);
    mike.talk(`I've literally been standing there just ten minutes ago for two hours!`);
    ImageClass.setImage(images.v9.V9AnnMCMotelDriving_28);
    tyler.talk(`So?`);
    ImageClass.setImage(images.v9.V9AnnMCMotelDriving_29);
    mike.talk(`Just make sure you don't miss anyone!`);
    ImageClass.setImage(images.v9.V9AnnMCMotelDriving_27);
    tyler.talk(`${mike.name}...?`);
    mike.talk(`Huh?`);
    tyler.talk(`If you die first, do I have permission to eat you?`);
    mike.talk(`Only the toes.`);
    tyler.talk(`I Guess I'll die right right after you then.`);
    ImageClass.setImage(images.v9.V9AnnMCMotelDriving_29);
    tyler.talk(`We're so screwed! No one is passing through.`);
    mc.think(`I can offer them a ride...\nBut the car is way too small for both of them to cram in the back.`);
    await mc.setQuestion(new Question({ text: `It means Ann will have to sit in the back with one of them.`, options: { think: true }, key: `v9AnnMCMotelMorningCalledTheGuysOver` })
        .option({ title: `Call them over`, key: true })
        .option({ title: `Just drive past them`, key: false }));

    if (Question.globalAnswers.v9AnnMCMotelMorningCalledTheGuysOver) {
        doWaitImageByTime(images.v9.V9AnnMCMotelDriving_26);
        mc.talk(`Yoooo! ${mike.name}!`, { method: "Shouting" });
        doWaitImageByTime(v9.V9AnnMCMotelDriving_30);
        mc.talk(`${tyler.name}!`, { method: "Shouting" });
        doWaitImageByTime(v9.V9AnnMCMotelDriving_31);
        mc.talk(`OVER HERE!`, { method: "Shouting" });
        doWaitImageByTime(v9.V9AnnMCMotelDriving_32);
        mike.talk(`${mc.name}, my man! Nice ride!`);
        ImageClass.setImage(images.v9.V9AnnMCMotelDriving_33);
        mc.talk(`Don't fuck with me!`);
        ImageClass.setImage(images.v9.V9AnnMCMotelDriving_32);
        mike.talk(`Sorry. I had to!`);
        mike.talk(`You have no idea how happy I am to see you!`);
        ImageClass.setImage(images.v9.V9AnnMCMotelDriving_33);
        mc.talk(`Do you guys need a ride?`);
        ImageClass.setImage(images.v9.V9AnnMCMotelDriving_32);
        mike.talk(`Dying to!`);
        ImageClass.setImage(images.v9.V9AnnMCMotelDriving_33);
        mc.talk(`Why didn't you ask for one yesterday?`);
        ImageClass.setImage(images.v9.V9AnnMCMotelDriving_32);
        mike.talk(`We were sure we'd be able to find a ride easily...`);
        mike.talk(`Besides, you've already done so much, we didn't want to leech off you.`);
        ImageClass.setImage(images.v9.V9AnnMCMotelDriving_33);
        mc.talk(`Don't insult me.`);
        ImageClass.setImage(images.v9.V9AnnMCMotelDriving_32);
        mike.talk(`You're a lifesaver!`);
        mike.talk(`Let us just hop in the back.`);
        doWaitImageByTime(images.v9.V9AnnMCMotelDriving_35);
        mc.talk(`Both of you won't fit back there.`);
        mc.talk(`Ann will just have move to the back.`);
        ImageClass.setImage(images.v9.V9AnnMCMotelDriving_34);
        ann.talk(`Heyyy!`);
        ImageClass.setImage(images.v9.V9AnnMCMotelDriving_36);
        mc.talk(`Is that okay with you?`);
        ImageClass.setImage(images.v9.V9AnnMCMotelDriving_37);
        ann.talk(`Of course!`);
        ImageClass.setImage(images.v9.V9AnnMCMotelDriving_53);
        await mc.setQuestion(new Question({ text: `Let's see... Who is going to sit with Ann at the back...`, options: { think: true }, key: `v9AnnMCMotelMorningWhoSitWithAnnOptions` })
            .option({ title: `${mike.name}`, key: `mike` })
            .option({ title: `${tyler.name}`, key: `tyler` })
            .option({ title: `Let Ann decide`, key: `annDecide` }));

        if (Question.globalAnswers.v9AnnMCMotelMorningWhoSitWithAnnOptions === "mike") {
            ImageClass.setImage(images.v9.V9AnnMCMotelDriving_37);
            ann.talk(`Mike!`);
            ImageClass.setImage(images.v9.V9AnnMCMotelDriving_33);
            mc.talk(`${tyler.name}, hop on in the front; ${mike.name} will sit in the back with Ann.`);
        } else if (Question.globalAnswers.v9AnnMCMotelMorningWhoSitWithAnnOptions === "tyler") {
            ImageClass.setImage(images.v9.V9AnnMCMotelDriving_37);
            ann.talk(`Tyler!`);
            ImageClass.setImage(images.v9.V9AnnMCMotelDriving_33);
            mc.talk(`${mike.name}, hop on in the front; ${tyler.name} will sit in the back with Ann.`);
        } else {
            ImageClass.setImage(images.v9.V9AnnMCMotelDriving_37);
            mc.talk(`It's only fair if you decide who you want in the back with you.`);
            ImageClass.setImage(images.v9.V9AnnMCMotelDriving_54);
            ann.talk(`Hmm... Let me think.`);
            let dudeInFront = `${mike.name}`;
            ImageClass.setImage(images.v9.V9AnnMCMotelDriving_37);
            if (Question.globalAnswers.V1NtrUnexpected || Question.globalAnswers.v9AnnMCMotelGuysInsideWhoSleepSofa === "mc" || Question.globalAnswers.v9AnnMCMotelGuysInsideWhoSleepSofa === "mike") {
                ann.talk(`${tyler.name}.`);
            } else {
                dudeInFront = `${tyler.name}`;
                ann.talk(`${mike.name}.`);
            }
            ImageClass.setImage(images.v9.V9AnnMCMotelDriving_53);
            mc.talk(`Works for me.`);
            ImageClass.setImage(images.v9.V9AnnMCMotelDriving_33);
            mc.talk(`${dudeInFront}, get in front.`);
            if (dudeInFront === tyler.name) {
                tyler.talk(`Sweet!`);
            } else {
                ImageClass.setImage(images.v9.V9AnnMCMotelDriving_32);
                mike.talk(`Let's go!`);
            }
        }
        return jump(V9AnnMCMotel_Morning_GuysOutside_Driving, "V9AnnMCMotel_Morning_GuysOutside_Driving");
    }
    return jump(V9AnnMCMotel_End, "V9AnnMCMotel_End");
};

export const V9AnnMCMotel_Morning_GuysOutside_Driving = async (): Promise<any> => {

    let dudeInFront = mike;
    let dudeInBack = tyler;
    if (Question.globalAnswers.v9AnnMCMotelMorningWhoSitWithAnnOptions === "mike") {
        dudeInFront = tyler;
        dudeInBack = mike;

    }
    doWaitImageByTime(v9.V9AnnMCMotelDriving_55);
    dudeInFront.talk(`Thanks again man. You are a life saver!`);
    ImageClass.setImage(images.v9.V9AnnMCMotelDriving_56);
    mc.talk(`Don't sweat it.`);
    mc.talk(`You know...`);
    mc.talk(`You never told me where you guys are headed.`);
    ImageClass.setImage(v9.V9AnnMCMotelDriving_57);
    dudeInFront.talk(`Seriously?`);
    ImageClass.setImage(v9.V9AnnMCMotelDriving_55);
    if (Question.globalAnswers.v9AnnMCMotelMorningWhoSitWithAnnOptions === "mike") {
        dudeInFront.talk(`You are looking at the the two-time, back-to-back, grand champion of the Ultimate Sausage Eating Contest`);

    } else {
        dudeInFront.talk(`Well, Tyler here is the the two-time, back-to-back, grand champion of the Ultimate Sausage Eating Contest.`);

    }
    ImageClass.setImage(v9.V9AnnMCMotelDriving_56);
    mc.talk(`Seriously? You almost spent the night on the streets for that?`);
    mc.talk(`And I didn't even mention the fact that without me you would probably been gone for waiting for a ride.`);
    ImageClass.setImage(v9.V9AnnMCMotelDriving_57);
    dudeInFront.talk(`Bro, you don't need to rub it in.`);
    ImageClass.setImage(v9.V9AnnMCMotelDriving_58);
    dudeInFront.talk(`But to answer your question. YES. It is important! We can't give up the title.`);
    ImageClass.setImage(v9.V9AnnMCMotelDriving_57);
    dudeInFront.talk(`You won't believe me, but there is this thin chick that can swallow two sausages in one go!`);
    ImageClass.setImage(v9.V9AnnMCMotelDriving_58);
    dudeInFront.talk(`What the fuck is that all about?`);
    ImageClass.setImage(v9.V9AnnMCMotelDriving_56);
    mc.talk(`That's impressive.`);
    ImageClass.setImage(v9.V9AnnMCMotelDriving_57);
    if (Question.globalAnswers.v9AnnMCMotelMorningWhoSitWithAnnOptions === "mike") {
        dudeInFront.talk(`She was the runner-up after the champ over here.`);

    } else {
        dudeInFront.talk(`She was the runner-up after the champ over there.`);

    }


    ImageClass.setImage(v9.V9AnnMCMotelDriving_56);
    mc.talk(`I've got to see this contest one day. It sounds... Interesting.`);
    ImageClass.setImage(v9.V9AnnMCMotelDriving_57);
    dudeInFront.talk(`Oh, it's a sight alright. People from all over, coming together for the love of sausages.`);
    mc.talk(`And here I thought eating contests were just about, you know, eating.`);
    ImageClass.setImage(v9.V9AnnMCMotelDriving_57);
    dudeInFront.talk(`There's a whole culture, man. Techniques, rivalries, the psychology of it. It's deep.`);
    ImageClass.setImage(v9.V9AnnMCMotelDriving_56);
    mc.talk(`Psychology? Really?`);
    ImageClass.setImage(v9.V9AnnMCMotelDriving_57);
    dudeInFront.talk(`Yeah, you've got to psych out your opponents. Stare them down with a sausage in your hand. Show them you're not afraid to go the distance.`);
    ImageClass.setImage(v9.V9AnnMCMotelDriving_56);
    mc.talk(`Sounds intense.`);
    ImageClass.setImage(v9.V9AnnMCMotelDriving_57);
    dudeInFront.talk(`It is. But at the end of the day, it's all about the community. And the sausages, obviously.`);
    ImageClass.setImage(v9.V9AnnMCMotelDriving_56);
    mc.talk(`Well, good luck defending your title. I'll be rooting for you guys.`);
    ImageClass.setImage(v9.V9AnnMCMotelDriving_57);
    dudeInFront.talk(`Thanks, man. We'll need all the support we can get. Especially with the sausage-swallowing prodigy on our tails.`);
    ImageClass.setImage(v9.V9AnnMCMotelDriving_56);
    mc.talk(`Just make sure to bring home the trophy. And maybe some sausages for a victory barbecue?`);
    ImageClass.setImage(v9.V9AnnMCMotelDriving_57);
    dudeInFront.talk(`Oh no, there is no trophy.`);
    ImageClass.setImage(v9.V9AnnMCMotelDriving_56);
    mc.talk(`Are you seriously? No trophy?`);
    mc.talk(`So what do you get from all of that?`);
    ImageClass.setImage(v9.V9AnnMCMotelDriving_55);
    if (Question.globalAnswers.v9AnnMCMotelMorningWhoSitWithAnnOptions === "mike") {
        dudeInFront.talk(`A free meal.`);

    } else {
        dudeInFront.talk(`The enjoyment of watching my best friend throw-up and pass out.`);
        ImageClass.setImage(v9.V9AnnMCMotelDriving_56);
        mc.talk(`Does it happen on the regular?`);
        ImageClass.setImage(v9.V9AnnMCMotelDriving_57);
        dudeInFront.talk(`It never happened, but we have a bet it will.`);
        ImageClass.setImage(v9.V9AnnMCMotelDriving_58);
        dudeInFront.talk(`And I have faith.`);
        ImageClass.setImage(v9.V9AnnMCMotelDriving_56);
        mc.talk(`I see.`);

    }

    mc.talk(`...`);
    doWaitImageByTime(v9.V9AnnMCMotelDriving_59);
    mc.talk(`Are you guys okay back there? You are pretty quiet.`);
    doWaitImageByTime(v9.V9AnnMCMotelDriving_15);
    dudeInBack.talk(`Yes, we are doing absolutely fine.`);
    doWaitImageByTime(v9.V9AnnMCMotelDriving_17);
    mc.think(`I realized that all this time that I was having a chitchat with ${dudeInFront.name}, Ann was giving a blowjob to ${dudeInBack.name}.`);
    doWaitImageByTime(v9.V9AnnMCMotelDriving_18);

    if (isAnnMotelHadSexWithBothGuys()) {
        mc.think(`I shouldn't get excited by it, they already did everything yesterday.`);
        mc.think(`She's just feeling comfortable around them.`);
    } else if ((isAnnMotelHadSexWithTyler() && dudeInBack.name === tyler.name) || (isAnnMotelHadSexWithMike() && dudeInBack.name === tyler.name)) {
        mc.think(`I encouraged her to fuck him yesterday so it's obvious she's feeling comfortable around him.`);

    } else {
        if (Question.globalAnswers.v9AnnMCMotelBlowjobToGuyOnSofa) {
            mc.think(`I guess he grew an apatite after she gave him a handjob while he was sleeping.`);
        } else if (Question.globalAnswers.v9AnnMCMotelBlowjobToGuyOnSofa === false) {
            mc.think(`I guess she felt sorry for him after she didn't give him a handjob yesterday.`);
        } else {
            // didn't have sex with neither or gave hj
        }
    }
    return jump(V9AnnMCMotel_End, "V9AnnMCMotel_End");
};

export const V9AnnMCMotel_End = async (): Promise<any> => {
    doWaitImageByTime(v9.V9AnnMCMotelDriving_26);
    mc.think(`Better just keep driving.`);
    mc.think(`We'll be there in no time.`);
    await globals.set((properties) => {
        properties.playedVersion === "0.9a";
    });

    Game.showEnding("alpha");
};

